import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Locale: any;
  URL: any;
  UUID: any;
  _FieldSet: any;
}

/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  /** Localization messages will be replaced with their namespace and loc key. */
  DEBUG = 'DEBUG',
  /** None of the ALTER experiments will be used when resolving localization messages. */
  NONE = 'NONE',
  /** Both released and draft ALTER experiments will be used when resolving localization messages. */
  PREVIEW = 'PREVIEW',
  /** This is the default. Only released ALTER experiments will be used when resolving localization messages. */
  RELEASED = 'RELEASED'
}

/** Possible aspect ratios of EGDS images */
export enum AspectRatio {
  /** Aspect ratio 4:1 */
  FOUR_ONE = 'FOUR_ONE',
  /** Aspect ratio 4:3 */
  FOUR_THREE = 'FOUR_THREE',
  /** Aspect ratio 1:1 */
  ONE_ONE = 'ONE_ONE',
  /** Aspect ratio 16:9 */
  SIXTEEN_NINE = 'SIXTEEN_NINE',
  /** Aspect ratio 3:4 */
  THREE_FOUR = 'THREE_FOUR',
  /** Aspect ratio 3:2 */
  THREE_TWO = 'THREE_TWO',
  /** Aspect ratio 21:9 */
  TWENTY_ONE_NINE = 'TWENTY_ONE_NINE'
}

export interface AuthenticatedUserMenu extends EgdsMenu {
  __typename: 'AuthenticatedUserMenu';
  accessibility?: Maybe<Scalars['String']>;
  analytics?: Maybe<ClientSideAnalytics>;
  buttons: Array<EgdsButton>;
  disabled: Scalars['Boolean'];
  icon?: Maybe<Icon>;
  subMenus: Array<EgdsSubMenu>;
  title: Scalars['String'];
}

export interface Authentication {
  __typename: 'Authentication';
  /** Buttons functionality related to the user's authenticated state. */
  buttons: Array<EgdsButton>;
  /** Authenticated User functionality related to the authenticated user state. */
  menu?: Maybe<AuthenticatedUserMenu>;
}

export enum AuthenticationState {
  ANONYMOUS = 'ANONYMOUS',
  AUTHENTICATED = 'AUTHENTICATED',
  IDENTIFIED = 'IDENTIFIED'
}

/** Type used during a product search to specify a given boolean value like the fact customer would prefer to search for direct flights only. */
export interface BooleanValue {
  __typename: 'BooleanValue';
  id: Scalars['String'];
  value: Scalars['Boolean'];
}

/**
 *
 *     Represents a template and what type of plurality it represents.
 *
 */
export interface CardinalTemplate {
  __typename: 'CardinalTemplate';
  category: PluralCategory;
  template: Scalars['String'];
}

/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: Scalars['String'];
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: InputMaybe<Scalars['String']>;
}

/** Used to capture client side analytics event like clicks. See https://pages.github.expedia.biz/Brand-Expedia/bernie/docs/analytics-click-events/ */
export interface ClientSideAnalytics {
  __typename: 'ClientSideAnalytics';
  eventType?: Maybe<EgReferrerEventType>;
  linkName: Scalars['String'];
  referrerId: Scalars['String'];
  uisPrimeMessages: Array<EgUisMicroMessage>;
  urls?: Maybe<Array<Scalars['URL']>>;
}

/** Used to capture client side analytics event for tracking impression of a UI component */
export interface ClientSideImpressionEventAnalytics {
  __typename: 'ClientSideImpressionEventAnalytics';
  /** Represents event name */
  event: Scalars['String'];
  /** Represents link name for referrer event */
  linkName?: Maybe<Scalars['String']>;
  /** Represents id for referrer event */
  referrerId: Scalars['String'];
  /** Represents uis prime messages */
  uisPrimeMessages: Array<EgUisMicroMessage>;
  /**
   * Represents url of the component to be tracked
   * @deprecated Please use the URLs list field
   */
  url?: Maybe<Scalars['URL']>;
  /** A list of URLs to be requested for the impression event */
  urls?: Maybe<Array<Scalars['URL']>>;
}

/**
 *
 *     Represents the dynamic part of the composite text.  Keys are used to insert the localized fragment into
 *     the EGDSCompositeLocalizedText's template.
 *
 */
export interface CompositeLocalizedTextModel {
  __typename: 'CompositeLocalizedTextModel';
  key: Scalars['String'];
  /** @deprecated Use models instead */
  localizedFragment: EgdsLocalizedText;
  models: EgdsTemplateModels;
}

/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export enum ContainerTheme {
  DEFAULT = 'DEFAULT',
  IMPORTANT = 'IMPORTANT'
}

/** The input BEX context used for identifying users, sites and other platform functions. See the platform-expsite docs for more info: https://docweb.prod.expedia.com/expsite */
export interface ContextInput {
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: InputMaybe<Scalars['String']>;
  /** Debugging context, such as Abacus overrides */
  debugContext?: InputMaybe<DebugContextInput>;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: InputMaybe<Scalars['Int']>;
  /** The context locale, e.g. en_US */
  locale: Scalars['Locale'];
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: InputMaybe<PrivacyTrackingState>;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: Scalars['Int'];
  /** The legacy TravelProductID */
  tpid?: InputMaybe<Scalars['Int']>;
}

/** A common date object */
export interface Date {
  __typename: 'Date';
  /** The day of the month, e.g. `1` for the 1st */
  day: Scalars['Int'];
  /**
   * Format with a pattern. 'd MMM uuuu' will format 2011-12-03 as '3 Dec 2011'
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  formatted: Scalars['String'];
  /**
   * Format with a pattern. 'd MMM uuuu' will format 2011-12-03 as '3 Dec 2011', This is specifically for the cases when GraphQlContext does not get injected after sdk upgrade
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  formattedDate: Scalars['String'];
  /**
   * Get a localized full date string i.e. en='Tue, Oct 13' de='Di. 13 Oct
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  fullDateFormat?: Maybe<Scalars['String']>;
  /**
   * Get a simple string in ISO local date format '2011-12-03'
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  isoFormat: Scalars['String'];
  /**
   * Get a localized long date string i.e. en='Feb 26, 2020' de='26. Feb. 2020
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  longDateFormat?: Maybe<Scalars['String']>;
  /**
   * Get a localized medium date string i.e. en='Feb 26' de='26. Feb.
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  mediumDateFormat?: Maybe<Scalars['String']>;
  /** The numeric month, e.g. `1` for January */
  month: Scalars['Int'];
  /**
   * Get a localized short date string i.e. en='2/26/2020' de='26.02.2020
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  shortDateFormat?: Maybe<Scalars['String']>;
  /** The four-digit year e.g. `1999` */
  year: Scalars['Int'];
}


/** A common date object */
export interface DateFormattedArgs {
  format: Scalars['String'];
}


/** A common date object */
export interface DateFormattedDateArgs {
  format: Scalars['String'];
}

/** Type used during a product search to specify a given date. Usually this date would not be a core search criteria like a departure day for a flight. */
export interface DateValue {
  __typename: 'DateValue';
  id: Scalars['String'];
  value: Date;
}

/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: Array<ExposureInput>;
  /** ALTER mode */
  alterMode?: InputMaybe<AlterMode>;
}

/** Device information */
export interface DeviceInput {
  type: DeviceType;
}

/** Valid device types */
export enum DeviceType {
  APP_PHONE = 'APP_PHONE',
  APP_TABLET = 'APP_TABLET',
  CHAT_APP = 'CHAT_APP',
  DESKTOP = 'DESKTOP',
  MOBILE_PHONE = 'MOBILE_PHONE',
  MOBILE_TABLET = 'MOBILE_TABLET',
  VOICE_APP = 'VOICE_APP'
}

/** Dimensions for a presentation object i.e. image or icon */
export interface DimensionsInput {
  density: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
}

export interface Documentation {
  __typename: 'Documentation';
  /** Query used to get customer survey in Developer Hub. */
  customerSurvey: DocumentationCustomerSurveyResponse;
  /** Query used to get document for Developer Hub. */
  document: DocumentationDocumentResponse;
  /** Query used to get the feedback form for the Developer Hub. */
  feedback: DocumentationFeedbackResponse;
  /** Query used to render a header component for Developer Hub. */
  header: DocumentationHeaderResponse;
  /** Query used to render a navigation for Developer Hub. */
  navigation?: Maybe<DocumentationNavigationResponse>;
  /** Query used to get related documents for certain document in Developer Hub. */
  relationships: DocumentationRelationshipsResponse;
  /** Query used to get sandbox document for Developer Hub. */
  sandbox: DocumentationDocumentResponse;
  /** Query used to search in hub documents. */
  search: DocumentationSearchResponse;
}


export interface DocumentationDocumentArgs {
  id: Scalars['String'];
}


export interface DocumentationNavigationArgs {
  parentId: Scalars['String'];
}


export interface DocumentationRelationshipsArgs {
  id: Scalars['String'];
}


export interface DocumentationSandboxArgs {
  documentId?: InputMaybe<Scalars['String']>;
  referencePath: Scalars['String'];
}


export interface DocumentationSearchArgs {
  term: Scalars['String'];
}

/** Customer survey */
export interface DocumentationCustomerSurveyResponse extends DocumentationQueryResponse {
  __typename: 'DocumentationCustomerSurveyResponse';
  /** Customer survey button. */
  button: EgdsButton;
  /** Banners used to send notifications to users */
  notifications?: Maybe<Array<UiBanner>>;
}

/** Document error response when something wrong happens in the document query. */
export interface DocumentationDocumentErrorResponse extends DocumentationQueryResponse {
  __typename: 'DocumentationDocumentErrorResponse';
  /**
   * Button to navigate to the home page.
   * @deprecated Deprecated, replace with buttons
   */
  button: UiPrimaryButton;
  /** Buttons containing actions */
  buttons: Array<EgdsButton>;
  /** Document error message description wrapped in EDGS plain text component. */
  descriptionText: EgdsPlainText;
  /**
   * Document error message.
   * @deprecated Deprecated in favor of using EDGS components, replace with messageText
   */
  message: Scalars['String'];
  /** Document error message wrapped in EGDS plain text component. */
  messageText: EgdsPlainText;
  /** Banners used to send notifications to users */
  notifications?: Maybe<Array<UiBanner>>;
}

/** Document redirect */
export interface DocumentationDocumentRedirect extends DocumentationQueryResponse {
  __typename: 'DocumentationDocumentRedirect';
  /** Redirect link */
  link: UiLinkAction;
  /** Banners used to send notifications to users */
  notifications?: Maybe<Array<UiBanner>>;
}

/** Document data used to get the content for certain page in EG Developer Hub. */
export type DocumentationDocumentResponse = DocumentationDocumentErrorResponse | DocumentationDocumentRedirect | DocumentationDocumentSuccessResponse;

/** Document content for certain page in EG Developer Hub. */
export interface DocumentationDocumentSuccessResponse extends DocumentationQueryResponse {
  __typename: 'DocumentationDocumentSuccessResponse';
  /** Banners are used to notify users if the document not supported in requested locale. */
  banner?: Maybe<UiBanner>;
  /**
   * Document breadcrumbs.
   * @deprecated Deprecated, replace with navigationTrail
   */
  breadcrumbs?: Maybe<Array<EgdsStandardLink>>;
  /** Document content. */
  content: Scalars['String'];
  /** Document introduction. */
  intro?: Maybe<Scalars['String']>;
  /** Document redirection location. */
  location: Scalars['String'];
  /** Document breadcrumbs. */
  navigationTrail?: Maybe<Array<EgdsText>>;
  /** Banners used to send notifications to users */
  notifications?: Maybe<Array<UiBanner>>;
  /** Document thumbnail. */
  thumbnail: Image;
  /** Document title. */
  title: Scalars['String'];
}

export interface DocumentationFeedbackResponse extends DocumentationQueryResponse {
  __typename: 'DocumentationFeedbackResponse';
  /** Banners used to send notifications to users */
  notifications?: Maybe<Array<UiBanner>>;
  /** Feedback question content. */
  question: EgdsPlainText;
  /** Feedback suggestion form. */
  suggestionForm: SuggestionForm;
  /** Thumps down button */
  thumpsDown: UiPrimaryButton;
  /** Thumps up button */
  thumpsUp: UiPrimaryButton;
}

/** Header elements' union type */
export type DocumentationHeaderElement = DocumentationHeaderLogoElement | EgdsStandardLink;

/** Header logo element. */
export interface DocumentationHeaderLogoElement {
  __typename: 'DocumentationHeaderLogoElement';
  /** Alt text on the logo. Required for accessibility. */
  altText: Scalars['String'];
  /** Image source details. */
  imgSrc: Image;
}

export interface DocumentationHeaderMenuLinkItem extends EgdsMenuListItem {
  __typename: 'DocumentationHeaderMenuLinkItem';
  accessibility?: Maybe<Scalars['String']>;
  action: UiLinkAction;
  analytics?: Maybe<ClientSideAnalytics>;
  icon?: Maybe<Icon>;
  label: Scalars['String'];
  title: Scalars['String'];
}

/** Header data used to display the header for EG Developer Hub. */
export interface DocumentationHeaderResponse extends DocumentationQueryResponse {
  __typename: 'DocumentationHeaderResponse';
  /** Authorized and anonymous/unauthorized UX. */
  authentication: Authentication;
  /** Hub name */
  hubName: Scalars['String'];
  /** The list of locales supported by the hub. */
  languageMenu: EgdsMenu;
  /** The top section element of the header. */
  logo: DocumentationHeaderLogoElement;
  /** Banners used to send notifications to users */
  notifications?: Maybe<Array<UiBanner>>;
  /** The primary element in the bottom section of the header. */
  primaryNavigation: Array<DocumentationHeaderElement>;
  /** The search box element in the top section of the header. */
  searchBox: DocumentationHeaderSearchBoxElement;
  /** The secondary element in the bottom section of the header. */
  secondaryNavigation: Array<DocumentationHeaderElement>;
}

/** Header Search box element. */
export interface DocumentationHeaderSearchBoxElement {
  __typename: 'DocumentationHeaderSearchBoxElement';
  /** Search box icon. */
  icon: Icon;
  /** Search index file uri. */
  indexFileUri: Uri;
  /** Search box placeholder. */
  placeholder: Scalars['String'];
}

export interface DocumentationHeaderSubMenu extends EgdsSubMenu {
  __typename: 'DocumentationHeaderSubMenu';
  items: Array<EgdsMenuListItem>;
  title?: Maybe<Scalars['String']>;
}

export interface DocumentationMenu extends EgdsMenu {
  __typename: 'DocumentationMenu';
  accessibility?: Maybe<Scalars['String']>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  leadingIcon?: Maybe<Icon>;
  subMenus: Array<EgdsSubMenu>;
  title: Scalars['String'];
  trailingIcon?: Maybe<Icon>;
}

/** Navigation elements' union type */
export type DocumentationNavigationElement = DocumentationNavigationExpandoElement | DocumentationNavigationLinkElement | EgdsStandardLink;

export interface DocumentationNavigationExpandoElement {
  __typename: 'DocumentationNavigationExpandoElement';
  /** Badge to display to the right expando label */
  badge?: Maybe<EgdsBadge>;
  /**
   * Elements to render in the expando.
   * @deprecated Deprecated, as EGDSStandardLink does not support badges., replace with navigationElements
   */
  elements: Array<EgdsStandardLink>;
  /** Expando label. */
  label: Scalars['String'];
  /** Elements to render in the expando. */
  navigationElements: Array<DocumentationNavigationLinkElement>;
}

export interface DocumentationNavigationHeadingElement {
  __typename: 'DocumentationNavigationHeadingElement';
  /** Heading title. */
  title: EgdsStylizedText;
}

export interface DocumentationNavigationLinkElement {
  __typename: 'DocumentationNavigationLinkElement';
  /** Badge to display to the right of the link title */
  badge?: Maybe<EgdsBadge>;
  /** Link element */
  link: EgdsStandardLink;
}

/** Navigation data used to display the navigation for certain page in EG Developer Hub. */
export interface DocumentationNavigationResponse extends DocumentationQueryResponse {
  __typename: 'DocumentationNavigationResponse';
  elements: Array<DocumentationNavigationSectionElement>;
  heading: DocumentationNavigationHeadingElement;
  /** Banners used to send notifications to users */
  notifications?: Maybe<Array<UiBanner>>;
}

export interface DocumentationNavigationSectionElement {
  __typename: 'DocumentationNavigationSectionElement';
  /** Badge to display to the right of the section heading */
  badge?: Maybe<EgdsBadge>;
  /**
   * Elements to render in the section.
   * @deprecated Deprecated, as it returns EGDSStandardLink, which does not support badges, replace with navigationElements
   */
  elements: Array<DocumentationNavigationElement>;
  /** Text to display on the section header. */
  heading?: Maybe<Scalars['String']>;
  /** Icon to display with the section heading */
  icon?: Maybe<Icon>;
  /** Elements to render in the section. */
  navigationElements: Array<DocumentationNavigationElement>;
}

export interface DocumentationQueryResponse {
  notifications?: Maybe<Array<UiBanner>>;
}

export interface DocumentationRelatedDocument {
  __typename: 'DocumentationRelatedDocument';
  /** Document intro. */
  subtitle?: Maybe<EgdsPlainText>;
  title: EgdsStylizedText;
  url: UiLinkAction;
}

/** Related documents of a Document Node. */
export interface DocumentationRelatedSection extends DocumentationQueryResponse {
  __typename: 'DocumentationRelatedSection';
  /** Elements related to the Document Node. */
  elements: Array<DocumentationRelatedDocument>;
  /** Banners are used to notify users if something happens in the related section query */
  notifications?: Maybe<Array<UiBanner>>;
  /** Related elements section title. */
  title: EgdsStylizedText;
}

/** Relationships error response when something wrong happens in the relationships query. */
export interface DocumentationRelationshipsErrorResponse extends DocumentationQueryResponse {
  __typename: 'DocumentationRelationshipsErrorResponse';
  /** Relationships error message. */
  message: Scalars['String'];
  /** Banners used to send notifications to users */
  notifications?: Maybe<Array<UiBanner>>;
}

export type DocumentationRelationshipsResponse = DocumentationDocumentErrorResponse | DocumentationRelationshipsErrorResponse | DocumentationRelationshipsSuccessResponse;

/** Relationships between requested document and other documents */
export interface DocumentationRelationshipsSuccessResponse extends DocumentationQueryResponse {
  __typename: 'DocumentationRelationshipsSuccessResponse';
  /** Next Document. */
  next?: Maybe<EgdsStandardLink>;
  /** Banners used to send notifications to users */
  notifications?: Maybe<Array<UiBanner>>;
  /** Previous Document. */
  previous?: Maybe<EgdsStandardLink>;
  /** Related documents of a Document Node */
  related?: Maybe<DocumentationRelatedSection>;
}

/** Search Results data used to display the search results for EG Developer Hub */
export interface DocumentationSearchResponse extends DocumentationQueryResponse {
  __typename: 'DocumentationSearchResponse';
  /** Banners used to send notifications to users */
  notifications?: Maybe<Array<UiBanner>>;
  /** List of documents which contain the search term */
  searchResults: Array<DocumentationTypeaheadResult>;
}

export interface DocumentationTypeaheadResult {
  __typename: 'DocumentationTypeaheadResult';
  intro?: Maybe<Scalars['String']>;
  parentTitles?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  title: Scalars['String'];
}

/**
 *
 *     Representation for the duration span element.
 *
 */
export interface DurationSpan {
  /** Close button on the duration span dialog element. */
  closeButton: EgdsButton;
  /** Done button on the duration span dialog element. */
  doneButton: EgdsButton;
  /** Title for the duration span dialog element. Example: Cruise length, Trip Duration. */
  title: Scalars['String'];
}

/**
 *
 *     Input validation for the duration span element.
 *
 */
export interface DurationSpanInputValidation extends EgdsInputValidation {
  __typename: 'DurationSpanInputValidation';
  /**
   *
   *         Error message to display to the user whenever the validation fails.
   *
   */
  errorMessage: Scalars['String'];
  /** Component that shows an specific error when changes are tried to be saved. */
  errorSummary?: Maybe<EgdsErrorSummary>;
  /** Specifies the type of validation. */
  type: DurationSpanValidationType;
}

/**
 *
 *     Implementation for the duration span field selection element.
 *
 */
export interface DurationSpanSelector extends DurationSpan, EgdsElement {
  __typename: 'DurationSpanSelector';
  /** Close button on the duration span dialog element. */
  closeButton: EgdsButton;
  /** Done button on the duration span dialog element. */
  doneButton: EgdsButton;
  /** Duration span dialog element unique identifier. */
  egdsElementId?: Maybe<Scalars['String']>;
  /** Input field for the maximum span limit. */
  maxDurationSpanLimit: EgdsNumberInputField;
  /** Input field for the minimum span limit. */
  minDurationSpanLimit: EgdsNumberInputField;
  /** Title for the duration span dialog element. Example: Cruise length, Trip Duration. */
  title: Scalars['String'];
  /**
   *
   *     Validations with corresponding error messages to display to the user
   *     if the inputs don't fulfill the requirements. The order of the validations
   *     dictate the order in which the error messages are displayed.
   *
   */
  validations?: Maybe<Array<EgdsInputValidation>>;
}

/** Different types of duration span input validations. */
export enum DurationSpanValidationType {
  /** Used to validate that a maximum input value is greater than a minimum input value. */
  MAXIMUM_GREATER_THAN_MINIMUM = 'MAXIMUM_GREATER_THAN_MINIMUM',
  /** Used to validate that the user input is less than or equal to some specified value. Example: Maximum 10 nights. */
  MAXIMUM_VALUE = 'MAXIMUM_VALUE',
  /** Used to validate that a minimum input value is less than a maximum input value. */
  MINIMUM_LESS_THAN_MAXIMUM = 'MINIMUM_LESS_THAN_MAXIMUM',
  /** Used to validate that the user input is greater than or equal to some specified value. Example: Minimum 2 nights. */
  MINIMUM_VALUE = 'MINIMUM_VALUE',
  /** Used to validate that the user input has a value. */
  REQUIRED_VALUE = 'REQUIRED_VALUE'
}

/**
 *
 *     Representation of a badge, implementations could include status, saved, notification, etc.
 *
 *     https://www.figma.com/file/aYQZVH6x5kqAGj8LbLzTVWfX/Badges
 *
 */
export interface EgdsBadge {
  accessibility?: Maybe<Scalars['String']>;
  graphic?: Maybe<UiGraphic>;
  /** Represents display size of badge. Example: 'large', 'small' */
  size?: Maybe<Scalars['String']>;
  /** Text content to be displayed within the badge */
  text?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
}

/**
 *
 *     Represents a notification badge
 *     https://www.figma.com/file/aYQZVH6x5kqAGj8LbLzTVWfX/Badge?node-id=7738%3A8273
 *
 */
export interface EgdsBadgeNotification extends EgdsBadge, EgdsElement {
  __typename: 'EGDSBadgeNotification';
  accessibility?: Maybe<Scalars['String']>;
  /** Count value to be displayed within the badge */
  count?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  graphic?: Maybe<UiGraphic>;
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  size?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  /** Represents theme for notification badge. Possible values are 'unread', 'activity', 'action', 'default', 'inverse' */
  theme?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
}

/** Basic CheckBox element */
export interface EgdsBasicCheckBox extends EgdsCheckBox, EgdsElement {
  __typename: 'EGDSBasicCheckBox';
  /** analytics event to fire when checkbox is checked */
  checkedAnalytics?: Maybe<ClientSideAnalytics>;
  description?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  label: EgdsText;
  name?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  state: EgdsCheckBoxState;
  /** analytics event to fire when checkbox is unchecked */
  uncheckedAnalytics?: Maybe<ClientSideAnalytics>;
  /** Specifies the value associated with the checkbox if needed */
  value?: Maybe<Scalars['String']>;
}

/**
 *
 *     Represents the simplest type of localized string.  There are no plurals or fragments.
 *     Example: `Your trip to {destination}`, where `destination` is provided by the client
 *
 */
export interface EgdsBasicLocalizedText extends EgdsElement, EgdsTemplateModels, EgdsText {
  __typename: 'EGDSBasicLocalizedText';
  /**
   *
   *         Use this field when accessibility text needs to be different from text.
   *         Provide default accessibility value and fallback text
   *
   */
  accessibilityTemplate?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  /** Provide a list of template models. */
  models: Array<TemplateModel>;
  /**
   *
   *         Provide a template string.  Example:  `Your trip from {origin} to {destination}`
   *
   */
  template: Scalars['String'];
  /** Provide a default value */
  text: Scalars['String'];
}

/**
 *
 *    Represents basic implementation of EGDSOption.
 *
 */
export interface EgdsBasicOption extends EgdsElement, EgdsOption {
  __typename: 'EGDSBasicOption';
  changeAnalytics?: Maybe<ClientSideAnalytics>;
  egdsElementId?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  selected?: Maybe<Scalars['Boolean']>;
  value: Scalars['String'];
}

/**
 *
 * Represents basic key - value chips or pills
 * Clicking or tapping any part of the pill will toggle between select and deselect.
 *
 */
export interface EgdsBasicPill extends EgdsPill {
  __typename: 'EGDSBasicPill';
  /** Accessibility label for the pill */
  accessibility?: Maybe<Scalars['String']>;
  /** analytics tracking for the deselection of pill */
  deselectAnalytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  /** Icon to be displayed along with the label */
  icon?: Maybe<UiGraphic>;
  id?: Maybe<Scalars['String']>;
  /**
   *
   *         type `name` or param name of the pill.
   *         Ex: `paymentType` for a "Free Cancellation" filter pill
   *
   */
  name?: Maybe<Scalars['String']>;
  /** Label to be displayed on the pill */
  primary?: Maybe<Scalars['String']>;
  /** analytics tracking for the selection of pill */
  selectAnalytics?: Maybe<ClientSideAnalytics>;
  selected: Scalars['Boolean'];
  /** Label to be displayed on the pill when selected */
  selectedText?: Maybe<Scalars['String']>;
  /**
   *
   *         value of the pill.
   *         Ex: `FREE_CANCELLATION` for a "Free Cancellation" filter pill
   *
   */
  value?: Maybe<Scalars['String']>;
}

/** Basic radio button element */
export interface EgdsBasicRadioButton extends EgdsRadioButton {
  __typename: 'EGDSBasicRadioButton';
  description?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  label: Scalars['String'];
  labelSuffix?: Maybe<Scalars['String']>;
  value: Scalars['String'];
}

/** Basic radio group element */
export interface EgdsBasicRadioGroup extends EgdsRadioGroup {
  __typename: 'EGDSBasicRadioGroup';
  errorMessage?: Maybe<Scalars['String']>;
  groupName: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  options: Array<EgdsRadioButton>;
  selected?: Maybe<Scalars['String']>;
}

export interface EgdsBasicRemovablePill extends EgdsPill {
  __typename: 'EGDSBasicRemovablePill';
  /** Accessibility label for the pill */
  accessibility?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  /** Icon to be displayed along with the label */
  icon?: Maybe<UiGraphic>;
  id?: Maybe<Scalars['String']>;
  /**
   *
   *         type `name` or param name of the pill.
   *         Ex: `paymentType` for a "Free Cancellation" filter pill
   *
   */
  name?: Maybe<Scalars['String']>;
  /** Label to be displayed on the pill */
  primary?: Maybe<Scalars['String']>;
  /** denotes removal trigger of pill */
  remove?: Maybe<UiGraphic>;
  /** Voiceover text when pill is removed */
  removeAccessibility?: Maybe<Scalars['String']>;
  /** analytics tracking for the removal of pill */
  removeAnalytics?: Maybe<ClientSideAnalytics>;
  selected: Scalars['Boolean'];
  /**
   *
   *         value of the pill.
   *         Ex: `FREE_CANCELLATION` for a "Free Cancellation" filter pill
   *
   */
  value?: Maybe<Scalars['String']>;
}

/**
 *
 *     Represents the standard implementation of EGDSSectionHeading.
 *     This can be used for any Product specific use-cases
 *     A product can be an Activity / Property / Flight / Car etc.
 *
 *     eg it can represent section heading for a list of item.
 *
 */
export interface EgdsBasicSectionHeading extends EgdsSectionHeading {
  __typename: 'EGDSBasicSectionHeading';
  /** Represents the graphic rendered before heading */
  graphic?: Maybe<UiGraphic>;
  heading: EgdsHeading;
  subheading?: Maybe<Scalars['String']>;
}

/**
 *
 *    Represents basic implementation of EGDSSelect.
 *
 */
export interface EgdsBasicSelect extends EgdsElement, EgdsSelect {
  __typename: 'EGDSBasicSelect';
  clickAnalytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  icon?: Maybe<Icon>;
  label: Scalars['String'];
  options: Array<EgdsOption>;
  readOnly: Scalars['Boolean'];
  /** Informs the user if the field is mandatory. */
  required?: Maybe<Scalars['Boolean']>;
  /** Value for the select field */
  value?: Maybe<Scalars['String']>;
}

/**
 *
 *    Represents basic implementation of StepInput.
 *
 */
export interface EgdsBasicStepInput extends EgdsElement, EgdsStepInput {
  __typename: 'EGDSBasicStepInput';
  /** Analytics event to be fired whenever the value for this field decrease */
  decreaseAnalytics?: Maybe<ClientSideAnalytics>;
  decreaseText?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  /** Analytics event to be fired whenever the value for this field increase */
  increaseAnalytics?: Maybe<ClientSideAnalytics>;
  increaseText?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  step: Scalars['Int'];
  subLabel?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
}

/**
 *
 *    Represents basic implementation of EGDSTab.
 *
 */
export interface EgdsBasicTab extends EgdsElement, EgdsTab {
  __typename: 'EGDSBasicTab';
  accessibility?: Maybe<Scalars['String']>;
  clickAnalytics?: Maybe<ClientSideAnalytics>;
  egdsElementId?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  tabId: Scalars['String'];
}

/**
 *
 *    Represents basic implementation of EGDSTabs.
 *
 */
export interface EgdsBasicTabs extends EgdsElement, EgdsTabs {
  __typename: 'EGDSBasicTabs';
  egdsElementId?: Maybe<Scalars['String']>;
  selectedTabId?: Maybe<Scalars['String']>;
  tabs: Array<EgdsTab>;
}

/**
 *
 *    Represents implementation of traveler for traveler selector.
 *
 */
export interface EgdsBasicTraveler extends EgdsTraveler {
  __typename: 'EGDSBasicTraveler';
  ages?: Maybe<Array<EgdsSelect>>;
  count: EgdsStepInput;
  type?: Maybe<EgdsTravelerType>;
}

/**
 *
 *    Represents implementation of EGDSTravelerSelector which will be used for flight, activity, cruises or brands like Vrbo where room less travelers are required.
 *
 */
export interface EgdsBasicTravelerSelector extends EgdsElement, EgdsTravelerSelector {
  __typename: 'EGDSBasicTravelerSelector';
  closeButton: EgdsButton;
  doneButton: EgdsButton;
  egdsElementId?: Maybe<Scalars['String']>;
  /** Additional information displayed at travelers selector. Example: activity name/s. */
  subTitles?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  /** Represents travelers category for the travelers selector. */
  travelers?: Maybe<EgdsTravelers>;
  /**
   *
   *         Validations with corresponding error messages to display if the input is invalid.
   *         The order in which the validations appears indicates the order of priority of which error message to display.
   *
   */
  validations?: Maybe<Array<EgdsInputValidation>>;
}

/**
 *
 *     Triggers another component (e.g. Menu, Sheet, Full-screen dialog).
 *     Clicking or tapping any part of the pill will trigger the interaction.
 *
 */
export interface EgdsBasicTriggerPill extends EgdsPill {
  __typename: 'EGDSBasicTriggerPill';
  /** Accessibility label for the pill */
  accessibility?: Maybe<Scalars['String']>;
  /** analytics tracking for the deselection of pill */
  deselectAnalytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  /** Icon to be displayed along with the label */
  icon?: Maybe<UiGraphic>;
  id?: Maybe<Scalars['String']>;
  /** Label to be displayed on the pill */
  primary?: Maybe<Scalars['String']>;
  /** analytics tracking for the selection of pill */
  selectAnalytics?: Maybe<ClientSideAnalytics>;
  selected: Scalars['Boolean'];
  /** denotes Icon, that triggers to another component */
  trigger?: Maybe<UiGraphic>;
}

/** Bulleted variant of EGDS typography list */
export interface EgdsBulletedList extends EgdsElement, EgdsTextList {
  __typename: 'EGDSBulletedList';
  egdsElementId?: Maybe<Scalars['String']>;
  listItems: Array<EgdsTextListItem>;
  size?: Maybe<EgdsTextListSize>;
}

/** Intended to be implemented by EGDS Button objects (including variations) */
export interface EgdsButton {
  accessibility?: Maybe<Scalars['String']>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  /** Used to capture client side analytics on button click. */
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars['String']>;
}

/** Styles established in EGDS design docs. https://www.figma.com/file/bbPtPOgPN4sttR3BzDaTZc/Buttons */
export enum EgdsButtonStyle {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}

/**
 *
 *     Represents the variations of a card. Can be used with EGDSCard union members.
 *     https://www.figma.com/file/M3udFrUojCRwrcoAiPnQ3Yaw/Card?node-id=11143%3A833&t=blroVUeSfs4Eqnoj-0
 *
 */
export enum EgdsCardThemes {
  BORDERED = 'BORDERED',
  PADDED = 'PADDED'
}

/**
 *
 *     Represents localized text with cardinality.
 *
 *     Example: `{num} rooms` where `num` is provided by the client.
 *
 *     Note: "Cardinal" text is different than "Ordinal" text in that cardinal number tell "how many" (i.e. "2 rooms"),
 *     whereas ordinal numbers tell in which order (i.e. "2nd room").
 *
 */
export interface EgdsCardinalLocalizedText extends EgdsElement, EgdsTemplateModels, EgdsText {
  __typename: 'EGDSCardinalLocalizedText';
  /**
   *
   *         Use this field when accessibility text needs to be different from text. Provide a list of templates for all supported cardinal categories (0, 1, 2, few, many, other)
   *
   */
  accessibilityTemplates?: Maybe<Array<CardinalTemplate>>;
  /** Use this field when accessibility text needs to be different from text. Provide default accessibility value and fallback text */
  accessibilityText?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  /** Provide a list of template models. */
  models: Array<TemplateModel>;
  /**
   *
   *        Optional secondary templates for different texts than required templates. Example: "{travelerCount} traveler with pets"
   *
   */
  secondaryTemplates?: Maybe<Array<CardinalTemplate>>;
  /**
   *
   *        Provide a list of templates for all supported cardinal categories (0, 1, 2, few, many, other)
   *
   */
  templates: Array<CardinalTemplate>;
  /** Provide default localized string for initial value and fallback text */
  text: Scalars['String'];
}

/**
 *
 *     Represents a CheckBox element
 *     Ex. https://www.figma.com/file/fvv9g0KUyrhcLSErmT6Cd5/EGID---Registration?node-id=3659%3A51102
 *
 */
export interface EgdsCheckBox {
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  label: EgdsText;
  name?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  state: EgdsCheckBoxState;
  value?: Maybe<Scalars['String']>;
}

/** Defines how checkbox state should be displayed on client. */
export enum EgdsCheckBoxState {
  CHECKED = 'CHECKED',
  INDETERMINATE = 'INDETERMINATE',
  UNCHECKED = 'UNCHECKED'
}

/**
 *
 * A text element or section of text that can be used to structure text content.
 * Examples include paragraphs, ordered/unordered lists, headings, and sections containing other text elements.
 *
 */
export type EgdsComposableTextElement = EgdsBulletedList | EgdsComposableTextElementSectionContainer | EgdsGraphicText | EgdsHeading | EgdsIconText | EgdsInlineLink | EgdsLinkList | EgdsOrderedList | EgdsParagraph | EgdsPlainText | EgdsSpannableText | EgdsStandardLink | EgdsStylizedText | EgdsTextIconList | EgdsTextListSection | EgdsTextSection | EgdsUnorderedList;

/**
 *
 *     This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 *     Most teams should just use Strings.
 *
 *     Contains other EGDSComposableTextElements such paragraphs, ordered/unordered lists, headings, and sections containing other text elements.
 *
 */
export interface EgdsComposableTextElementContainer {
  elements: Array<EgdsComposableTextElement>;
}

/**
 *
 *     This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 *     Most teams should just use Strings.
 *
 *     Groups text content and is composed of sections for the heading and body
 *
 */
export interface EgdsComposableTextElementSectionContainer extends EgdsComposableTextElementContainer, EgdsElement {
  __typename: 'EGDSComposableTextElementSectionContainer';
  egdsElementId?: Maybe<Scalars['String']>;
  elements: Array<EgdsComposableTextElement>;
  heading?: Maybe<EgdsSectionHeading>;
}

/**
 *
 *     Represents localized text consisting of multiple localized text fragments.  This is important, as grammar and
 *     syntax is different from language to language and simply concatenating two localized strings together often
 *     doesn't work.
 *     Example: `{rooms}, {travelers}`, where `rooms` is a localized string, such as `{num} rooms` and
 *     `travelers` is a localized string, such as `{num} travelers`
 *
 */
export interface EgdsCompositeLocalizedText extends EgdsElement, EgdsText {
  __typename: 'EGDSCompositeLocalizedText';
  egdsElementId?: Maybe<Scalars['String']>;
  /** Provide a list of composite models. */
  models: Array<CompositeLocalizedTextModel>;
  /**
   *
   *         Provide a template string.  Example:  `{rooms}, {travelers}`
   *
   */
  template: Scalars['String'];
  /** Provide a default value */
  text: Scalars['String'];
}

/**
 *
 *     Provide datepicker configuration to create calendar for date selection.
 *
 */
export interface EgdsDatePicker {
  /**
   *
   *         Text for full-width Floating Button at bottom of date picker.
   *         The button is used for completing user's selection and closing date picker.
   *         Example: "Done"
   *
   */
  buttonText: Scalars['String'];
  /**
   *
   *         Text for clear dates button.
   *         The button is used for clearing user's selection date picker.
   *         Example: "Clear dates"
   *
   */
  clearButtonText?: Maybe<Scalars['String']>;
  /** Used to capture client side analytics when user clicks clear dates button. */
  clearDatesButtonAnalytics?: Maybe<ClientSideAnalytics>;
  /** Provides a value format for the date fields. Example: 'yyyy-MM-dd' */
  dateFormat: Scalars['String'];
  /** Content to display themed text below each date (ie. price levels). */
  datePickerContent?: Maybe<Array<EgdsDatePickerContent>>;
  /**
   *
   *         Represents the first date of the week in the datepicker. Example: 'SUN'
   *         More details on UITK:
   *         http://uitk.expedia.biz/expedia/en_US/components/date-picker#datepicker
   *
   */
  firstDayOfWeek: EgdsDayName;
  /** Content to display flexibility modifier options relating to the date selection. (ie. '±3 days') */
  flexibleDateContent?: Maybe<EgdsDatePickerFlexibilityContent>;
  /** Provides a text value for the footer i.e. legal disclaimer */
  footerText?: Maybe<Scalars['String']>;
  /**
   *
   *         If non-null a start date will be preselected when you open the date picker.
   *         If null no start date will be selected and startDatePlaceholderText will be shown.
   *
   */
  selectedStartDate?: Maybe<Date>;
  /** Boolean to show or hide the clear dates button. */
  showClearDatesButton?: Maybe<Scalars['Boolean']>;
  /** Used to capture client side analytics when user clicks the start date button. */
  startDateButtonAnalytics?: Maybe<ClientSideAnalytics>;
  /**
   *
   *         Shown when user has not yet selected a start date.
   *         Example: "Start date"
   *
   */
  startDatePlaceholderText: Scalars['String'];
  /** Used to capture client side analytics when user submits the selected dates. */
  submitButtonAnalytics?: Maybe<ClientSideAnalytics>;
  /**
   *
   *         The first date where a selection is allowed.
   *         For example if you want to prohibit selecting dates in the past you can set this value to today's date.
   *
   */
  validDaysLowerBoundInclusive?: Maybe<Date>;
  /** The last date where a selection is allowed. */
  validDaysUpperBoundInclusive?: Maybe<Date>;
}

/**
 *
 *     Date picker content to display themed text below each date (ie. price levels).
 *
 */
export interface EgdsDatePickerContent {
  __typename: 'EGDSDatePickerContent';
  /** Accessibility text for screen readers. */
  accessibility?: Maybe<Scalars['String']>;
  /** Date (ie. 'yyyy-MM-dd') as key value for content object. */
  dateKey: Scalars['String'];
  /** Text content displayed below date. */
  text?: Maybe<Scalars['String']>;
  /** Theme to stylized the text. */
  theme?: Maybe<Scalars['String']>;
}

/**
 *
 *     Displays flexibility calendar content
 *
 */
export interface EgdsDatePickerFlexibilityCalendarContent {
  __typename: 'EGDSDatePickerFlexibilityCalendarContent';
  /** List of flexible date selection options within three days. */
  flexibleDateOptions: Array<EgdsBasicPill>;
  /** Element unique identifier. Used for identifying selected option within a form. */
  formElementId: Scalars['String'];
  /** Title for the flexibility content. Outlines the usage of the options. */
  title?: Maybe<EgdsPlainText>;
}

/**
 *
 *     "Content to display flexibility modifier options relating to the date selection to within three days."
 *
 */
export interface EgdsDatePickerFlexibilityContent {
  __typename: 'EGDSDatePickerFlexibilityContent';
  /** Used to show flexible content modifier options on the calendar section */
  calendarContent?: Maybe<EgdsDatePickerFlexibilityCalendarContent>;
  /** Element used to change between flexible calendar content (default date selector) and flexible date content (the user doesn't select a specific date, but nights and month range) */
  contentSelector?: Maybe<EgdsTabs>;
  /** Used to show date picker label based on selected flexible content selected */
  flexibilityLabel?: Maybe<EgdsCardinalLocalizedText>;
  /**
   * List of flexible date selection options within three days.
   * @deprecated Moved to EGDSDatePickerFlexibilityCalendarContent type
   */
  flexibleDateOptions: Array<EgdsBasicPill>;
  /** Used to show flexible dates content section */
  flexibleDatesContent?: Maybe<EgdsDatePickerFlexibilityDatesContent>;
  /**
   * Element unique identifier. Used for identifying selected option within a form.
   * @deprecated Moved to EGDSDatePickerFlexibilityCalendarContent type
   */
  formElementId: Scalars['String'];
  /**
   * Title for the flexibility content. Outlines the usage of the options.
   * @deprecated Moved to EGDSDatePickerFlexibilityCalendarContent type
   */
  title?: Maybe<EgdsPlainText>;
}

/**
 *
 *     Displays flexibility date content
 *
 */
export interface EgdsDatePickerFlexibilityDatesContent {
  __typename: 'EGDSDatePickerFlexibilityDatesContent';
  /** Displays months section */
  monthsSelection?: Maybe<EgdsDatePickerFlexibleMonths>;
  /** Displays nights section */
  nightsSelection?: Maybe<EgdsDatePickerFlexibleNights>;
}

/**
 *
 *     Displays flexibility months content
 *
 */
export interface EgdsDatePickerFlexibleMonths {
  __typename: 'EGDSDatePickerFlexibleMonths';
  /** Static text to be shown */
  heading?: Maybe<Scalars['String']>;
  /** Months options to be selected */
  options: EgdsToggleButtonGroup;
  /** Static sub text to be shown */
  subHeading: Scalars['String'];
}

/**
 *
 *     Displays flexibility nights content
 *
 */
export interface EgdsDatePickerFlexibleNights {
  __typename: 'EGDSDatePickerFlexibleNights';
  /** Static text to be shown */
  heading?: Maybe<Scalars['String']>;
  /** Checkbox to be checked if weekends are included or not in the search */
  includeWeekend: EgdsBasicCheckBox;
  /** Nights options to be selected */
  options: Array<EgdsBasicPill>;
}

export interface EgdsDatePickerInputField extends EgdsInputField {
  __typename: 'EGDSDatePickerInputField';
  /** Provides a value format for the date fields */
  dateFormat?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars['String']>;
  readOnly: Scalars['Boolean'];
  required?: Maybe<Scalars['Boolean']>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars['String']>;
}

export interface EgdsDateRangePicker extends EgdsDatePicker {
  __typename: 'EGDSDateRangePicker';
  buttonText: Scalars['String'];
  /**
   *
   *         Used to dynamically update the button text in the client, based on user interaction with the input date picker."
   *
   */
  buttonTextTemplate?: Maybe<EgdsLocalizedText>;
  clearButtonText?: Maybe<Scalars['String']>;
  clearDatesButtonAnalytics?: Maybe<ClientSideAnalytics>;
  dateFormat: Scalars['String'];
  datePickerContent?: Maybe<Array<EgdsDatePickerContent>>;
  /** Used to capture client side analytics when user clicks the end date button. */
  endDateButtonAnalytics?: Maybe<ClientSideAnalytics>;
  /**
   *
   *         Shown when user has not yet selected an end date.
   *         Example: "End date"
   *
   */
  endDatePlaceholderText: Scalars['String'];
  firstDayOfWeek: EgdsDayName;
  flexibleDateContent?: Maybe<EgdsDatePickerFlexibilityContent>;
  footerText?: Maybe<Scalars['String']>;
  /**
   *
   *         If non-null the maximum number of days that a date range selection can contain.
   *         Example use case: A hotel stay can be no longer than <maxNumberOfDaysSelected> days.
   *
   */
  maxNumberOfDaysSelected?: Maybe<Scalars['Int']>;
  /**
   *
   *             Used to capture client side analytics when user clicks next month in calendar.
   *
   */
  nextButtonAnalytics?: Maybe<ClientSideAnalytics>;
  /**
   *
   *             Used to capture client side analytics when user clicks previous month in calendar.
   *
   */
  previousButtonAnalytics?: Maybe<ClientSideAnalytics>;
  /**
   *
   *             If true start and end date can be the same.
   *             If false start and end date must be different.
   *             Example use case: False for hotels when overnight stays required.
   *             Example use case: True for flights that allow departure and arrival date to be the same.
   *
   */
  sameDaySelectionAllowed: Scalars['Boolean'];
  /**
   *
   *         If non-null an end date will be preselected when date picker is opened.
   *         If null no end date will be selected and endDatePlaceholderText will be shown.
   *
   */
  selectedEndDate?: Maybe<Date>;
  selectedStartDate?: Maybe<Date>;
  showClearDatesButton?: Maybe<Scalars['Boolean']>;
  startDateButtonAnalytics?: Maybe<ClientSideAnalytics>;
  startDatePlaceholderText: Scalars['String'];
  submitButtonAnalytics?: Maybe<ClientSideAnalytics>;
  validDaysLowerBoundInclusive?: Maybe<Date>;
  validDaysUpperBoundInclusive?: Maybe<Date>;
}

/** Represents short day name. */
export enum EgdsDayName {
  FRI = 'FRI',
  MON = 'MON',
  SAT = 'SAT',
  SUN = 'SUN',
  THU = 'THU',
  TUE = 'TUE',
  WED = 'WED'
}

/** Represents the type of decorative in the text element. e.g. superscript */
export enum EgdsDecorativeText {
  /** Renders with a background color to highlight the text */
  HIGHLIGHT = 'HIGHLIGHT',
  /** Renders with a line through the text */
  LINE_THROUGH = 'LINE_THROUGH',
  /** Renders as a subscript at the bottom of the text line */
  SUBSCRIPT = 'SUBSCRIPT',
  /** Renders as a superscript at the top of the text line */
  SUPERSCRIPT = 'SUPERSCRIPT',
  /** Renders with a line under the text */
  UNDERLINE = 'UNDERLINE'
}

/**
 *
 * Represents an action to dismiss the component
 *
 */
export interface EgdsDismissAction {
  __typename: 'EGDSDismissAction';
  accessibility?: Maybe<Scalars['String']>;
  analytics: ClientSideAnalytics;
  label?: Maybe<Scalars['String']>;
}

/**
 *
 * UI Element that is compliant with EGDS Component designs.
 * It is intended to be implemented by UIComposableElement, a union for shared EGDS Component models,
 * and candidates for UIComposableElement that are initially limited to an individual spinner's scope
 * to establish viability before being shared with other spinners as a member of UIComposableElement
 *
 */
export interface EgdsElement {
  /**
   *
   *     Element unique identifier. Uses include handling diffs for UI updates
   *     and identifying the source of data for user input fields
   *
   */
  egdsElementId?: Maybe<Scalars['String']>;
}

/**
 *
 * Implementations may include UI structures, layout templates, or view hierarchies.
 *
 */
export interface EgdsElements {
  elements: Array<EgdsElement>;
}

/** Represents an email input filed element with autofill property */
export interface EgdsEmailInputField extends EgdsElement, EgdsInputField {
  __typename: 'EGDSEmailInputField';
  /** Autofill hint for the input value */
  autofill?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars['String']>;
  readOnly: Scalars['Boolean'];
  required?: Maybe<Scalars['Boolean']>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars['String']>;
}

/**
 *
 *      Display summarized view of error when user has submitted the form with error in it.
 *
 */
export interface EgdsErrorSummary extends EgdsElement {
  __typename: 'EGDSErrorSummary';
  /** Information for capturing client side analytics event for error link clicks */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Description of error message below the heading */
  body?: Maybe<EgdsText>;
  egdsElementId?: Maybe<Scalars['String']>;
  /** Display link text when there's one error */
  goToErrorLinkText?: Maybe<Scalars['String']>;
  /** Display link text when there's more than one error */
  goToFirstErrorLinkText?: Maybe<Scalars['String']>;
  /** Represents main error message */
  heading: Scalars['String'];
  /** Display text with specified number of errors */
  headingTemplate?: Maybe<EgdsLocalizedText>;
  /** Information for capturing client side impression analytics event for error summary */
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
}

/** Represents a EGDS graphic menu */
export interface EgdsGraphicMenu extends EgdsMenu {
  __typename: 'EGDSGraphicMenu';
  accessibility?: Maybe<Scalars['String']>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  /** Represents the graphics used in the menu */
  graphic: UiGraphic;
  subMenus: Array<EgdsSubMenu>;
  title: Scalars['String'];
}

/** Represents a text a graphic element, icon or mark or ilustration */
export interface EgdsGraphicText extends EgdsText {
  __typename: 'EGDSGraphicText';
  graphic: UiGraphic;
  text: Scalars['String'];
  /** Represents a list of trailing graphics to be rendered after the text */
  trailingGraphics?: Maybe<Array<UiGraphic>>;
}

/**
 *
 *     Use this only in rare cases. This represents a heading of text with different EGDS typography styles; only use it in unique design cases where the UX changes frequently and specific product requirements must be met. Most teams should use String instead of EGDSHeading.
 *
 *     https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 *
 */
export interface EgdsHeading extends EgdsElement, EgdsText {
  __typename: 'EGDSHeading';
  /** Use this field when accessibility text needs to be different from text */
  accessibility?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  /**
   * Advanced feature. Only need for specific uses. See EGDSHeadingStyle description
   * @deprecated Tags should not be returned from API.
   */
  headingType?: Maybe<EgdsHeadingStyle>;
  text: Scalars['String'];
}

/**
 *
 *     This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 *     Most teams should just use String over EGDSHeading or EGDSText.
 *
 *     https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 *
 */
export enum EgdsHeadingStyle {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  H7 = 'H7',
  H8 = 'H8'
}

/** Represents where the icon should be places in a EGDS Standard Link */
export enum EgdsIconPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING'
}

/**
 *
 *    Represents icon and text
 *
 */
export interface EgdsIconText extends EgdsText {
  __typename: 'EGDSIconText';
  icon: Icon;
  text: Scalars['String'];
}

/** Represents an EGDS Image Link */
export interface EgdsImageLink extends EgdsElement {
  __typename: 'EGDSImageLink';
  /** Represents the action to perform when the image is selected */
  action: UiLinkAction;
  egdsElementId?: Maybe<Scalars['String']>;
  /** Display image that when selected performs an action */
  image: Image;
}

/**
 *
 *      Represents card with Image, text and link.
 *      figma: https://www.figma.com/file/M3udFrUojCRwrcoAiPnQ3Yaw/Card?node-id=474%3A114
 *
 */
export interface EgdsImageLinkCard extends EgdsElement {
  __typename: 'EGDSImageLinkCard';
  description?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  link: EgdsImageLink;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

/** Option for selecting an infant seat on a plane. */
export enum EgdsInfantSeat {
  IN_SEAT = 'IN_SEAT',
  ON_LAP = 'ON_LAP'
}

/** Radio button for selecting an infant seat on a plane. */
export interface EgdsInfantSeatRadioButton extends EgdsElement, EgdsRadioButton {
  __typename: 'EGDSInfantSeatRadioButton';
  description?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  labelSuffix?: Maybe<Scalars['String']>;
  seatType: EgdsInfantSeat;
  value: Scalars['String'];
}

/**
 *
 *    Represents an EGDS Inline Link
 *
 */
export interface EgdsInlineLink extends EgdsText {
  __typename: 'EGDSInlineLink';
  action: UiLinkAction;
  /** Display disabled link state. */
  disabled: Scalars['Boolean'];
  /** Display size of the link. */
  size: EgdsLinkSize;
  text: Scalars['String'];
}

/** Allows users to enter text-based information of various kinds such as destinations, credit cards, passwords, phones, etc */
export interface EgdsInputField {
  /** Text to be displayed as error text when the input field is in an invalid state. */
  errorMessage?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  /**
   *
   *         Used to dynamically update the label text in the client, based on user interaction with the input.
   *
   */
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars['String']>;
  /** Field is in a read-only state displaying only text when readOnly is true. */
  readOnly: Scalars['Boolean'];
  required?: Maybe<Scalars['Boolean']>;
  rightIcon?: Maybe<Icon>;
  /**
   *
   *         Validations with corresponding error messages to display if the input is invalid.
   *         The order in which the validations appears indicates the order of priority of which error message to display.
   *
   */
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars['String']>;
}

/** Used with input fields to specify validations that are attached to it */
export interface EgdsInputValidation {
  /**
   *
   *         The content of the error message may depend on the input or other factors,
   *         in which case implementations may need to add additional field/s
   *         or the structure the response in a way that allows for the appropriate message,
   *         and this would serve as the default error message.
   *
   */
  errorMessage: Scalars['String'];
}

/** Represents a list of EGDS Standard Links */
export interface EgdsLinkList extends EgdsElement {
  __typename: 'EGDSLinkList';
  egdsElementId?: Maybe<Scalars['String']>;
  listItems: Array<EgdsStandardLink>;
}

/** Represents the size of the text in a EGDS Standard Link */
export enum EgdsLinkSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

/** DEPRECATED: This interface allows for noncompliance to EGDS. */
export interface EgdsList {
  /** @deprecated This field allows for noncompliance to EGDS. Use EGDSTextList instead */
  items: Array<EgdsText>;
}

/**
 *
 *    Represents a localization template for text.
 *    It is required when client side interpolation has placeholder values: Example: `Room {roomIndex}`
 *    In above example value of roomIndex will replaced by clients.
 *
 */
export type EgdsLocalizedText = EgdsBasicLocalizedText | EgdsCardinalLocalizedText | EgdsCompositeLocalizedText;

/**
 *
 *    Represents a localization template for text.
 *    It is required when client side interpolation has placeholder values: Example: 'Room {roomIndex}'
 *    In above example value of roomIndex will replaced by clients.
 *
 */
export interface EgdsLocalizedTextTemplate extends EgdsElement, EgdsText {
  __typename: 'EGDSLocalizedTextTemplate';
  egdsElementId?: Maybe<Scalars['String']>;
  /** Localized string with tokens interpolated. Example: 'Room {roomIndex}' */
  template: Scalars['String'];
  /** Provide default localized string. Example: 'Room 1' */
  text: Scalars['String'];
  /** Replaceable placeholder. Example:in 'Room {roomIndex}' the 'roomIndex' is token. Clients should know the token in advance. */
  token: Scalars['String'];
}

/**
 *
 *     Represents a loyalty badge
 *
 *     https://www.figma.com/file/aYQZVH6x5kqAGj8LbLzTVWfX/Badges
 *
 */
export interface EgdsLoyaltyBadge extends EgdsBadge, EgdsElement {
  __typename: 'EGDSLoyaltyBadge';
  accessibility?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  graphic?: Maybe<UiGraphic>;
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  size?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
}

/** Specifies the maximum length that an input needs. For datepicker it can be use to validate maximum number of days. */
export interface EgdsMaxLengthInputValidation extends EgdsInputValidation {
  __typename: 'EGDSMaxLengthInputValidation';
  errorMessage: Scalars['String'];
  maxLength: Scalars['Int'];
}

/**
 *
 *     Representation of a EGDS menu
 *
 *     https://www.figma.com/file/cwNPDX6N1XTWCBQTp2PQ0t/Menus?node-id=746%3A152
 *
 *     UITK component defined at http://uitk.expedia.biz/expedia/en_US/components/menu"
 *
 */
export interface EgdsMenu {
  /** Represents the accessibility text for the menu */
  accessibility?: Maybe<Scalars['String']>;
  /** Used to capture client side analytics */
  analytics?: Maybe<ClientSideAnalytics>;
  /** User cannot interact with the menu when the disabled value is true. */
  disabled: Scalars['Boolean'];
  /** Represents the menu container */
  subMenus: Array<EgdsSubMenu>;
  /** Represents the title of the menu */
  title: Scalars['String'];
}

/** Represents a EGDS Menu icon items */
export interface EgdsMenuListIconTextItem extends EgdsMenuListItem {
  __typename: 'EGDSMenuListIconTextItem';
  accessibility?: Maybe<Scalars['String']>;
  analytics?: Maybe<ClientSideAnalytics>;
  /** Represents the graphics used in the menu list */
  graphic: UiGraphic;
  title: Scalars['String'];
}

/** Represents EGDS menu list item */
export interface EgdsMenuListItem {
  /** Represents the accessibility text for menu list item */
  accessibility?: Maybe<Scalars['String']>;
  /** Used to capture client side analytics */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Represents the menu list item title */
  title: Scalars['String'];
}

/** Represents an EGDS Menu standard item */
export interface EgdsMenuStandardItem extends EgdsMenuListItem {
  __typename: 'EGDSMenuStandardItem';
  accessibility?: Maybe<Scalars['String']>;
  action?: Maybe<UiLinkAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  icon?: Maybe<Icon>;
  title: Scalars['String'];
}

/** Represents a EGDS Menu text items */
export interface EgdsMenuTextItem extends EgdsMenuListItem {
  __typename: 'EGDSMenuTextItem';
  accessibility?: Maybe<Scalars['String']>;
  analytics?: Maybe<ClientSideAnalytics>;
  title: Scalars['String'];
}

/** Specifies the minimum length that an input needs */
export interface EgdsMinLengthInputValidation extends EgdsInputValidation {
  __typename: 'EGDSMinLengthInputValidation';
  errorMessage: Scalars['String'];
  minLength: Scalars['Int'];
}

/** EGDS Nested list item with icon level one */
export interface EgdsNestedLevelOneIconListItem extends EgdsNestedLevelOneListItem {
  __typename: 'EGDSNestedLevelOneIconListItem';
  icon: Icon;
  style?: Maybe<EgdsTextListItemStyle>;
  text: Scalars['String'];
}

/**
 *
 *         EGDS compliant nested list level one https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857
 *         Right now we are just adding level one as we don't have a use-case for further level, but we want to keep the schema extensible.
 *
 */
export interface EgdsNestedLevelOneList {
  __typename: 'EGDSNestedLevelOneList';
  /** List of item within nested list (level one) */
  items: Array<EgdsNestedLevelOneListItem>;
  /**
   *
   *             Represents the size property of the EGDS List, As per figma the default size is LIST_2
   *             figma: "https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=25%3A0"
   *
   */
  size: EgdsTextListSize;
  /**
   *
   *             Represents the UI variation of the EGDS List
   *             eg. BULLET, NO_BULLET, NUMBERED, ICON
   *             figma: "https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=25%3A0"
   *
   */
  type: EgdsTextListType;
}

/**
 *
 *         Nested list item (level one) with EGDS styles.
 *         figma: https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857")
 *
 */
export interface EgdsNestedLevelOneListItem {
  /**
   *
   *          Represents the text style of EGDS List Item (Level one)
   *          eg. EMPHASIS, POSITIVE, NEGATIVE etc
   *
   */
  style?: Maybe<EgdsTextListItemStyle>;
  text: Scalars['String'];
}

/** EGDS Nested list item level one */
export interface EgdsNestedLevelOneStandardListItem extends EgdsNestedLevelOneListItem {
  __typename: 'EGDSNestedLevelOneStandardListItem';
  style?: Maybe<EgdsTextListItemStyle>;
  text: Scalars['String'];
}

/** Represents a number input element */
export interface EgdsNumberInputField extends EgdsElement, EgdsInputField {
  __typename: 'EGDSNumberInputField';
  /**
   *
   *     Element unique identifier. Uses include handling diffs for UI updates
   *     and identifying the source of data for user input fields.
   *
   */
  egdsElementId?: Maybe<Scalars['String']>;
  /** Text to be displayed as error text when the input field is in an invalid state. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Detailed instructions to the user on how to use the input element. */
  instructions?: Maybe<Scalars['String']>;
  /** Text for the label element. */
  label?: Maybe<Scalars['String']>;
  /**
   *
   *     Used to dynamically update the label text in the client, based on user interaction with the input.
   *
   */
  labelTemplate?: Maybe<EgdsLocalizedText>;
  /** Icon to be positioned to the left side of the input element. */
  leftIcon?: Maybe<Icon>;
  /** Maximum value that can be entered for the input. */
  max?: Maybe<Scalars['Float']>;
  /** Minimum value that can be entered for the input. */
  min?: Maybe<Scalars['Float']>;
  /** Placeholder text for the input element. */
  placeholder?: Maybe<Scalars['String']>;
  /** Determines if the input element should be readonly. */
  readOnly: Scalars['Boolean'];
  /**
   *
   *     Informs the user if the field is mandatory. Sets the aria-required label for the field.
   *
   */
  required?: Maybe<Scalars['Boolean']>;
  /** Icon to be positioned to the right side of the input element. */
  rightIcon?: Maybe<Icon>;
  /** Interval number for the number input element. */
  step?: Maybe<Scalars['Float']>;
  /**
   *
   *     Validations with corresponding error messages to display if the input is invalid.
   *     The order in which the validations appears indicates the order of priority of which error message to display.
   *
   */
  validations?: Maybe<Array<EgdsInputValidation>>;
  /** Value for the input element. */
  value?: Maybe<Scalars['String']>;
}

/**
 *
 *     Action for opening date picker modal.
 *     The will work for native apps but not for UITK DatePicker because UITK couples the date picker with date input fields.
 *     For UITK DatePicker use EGDSCompositeDatePicker.
 *
 */
export interface EgdsOpenDatePickerAction extends UiAction {
  __typename: 'EGDSOpenDatePickerAction';
  accessibility?: Maybe<Scalars['String']>;
  analytics: ClientSideAnalytics;
  /** Date picker to open. */
  datePicker: EgdsDatePicker;
}

/**
 *
 *     Action for opening traveler selector.
 *     figma:
 *     https://www.figma.com/file/y59aHUdrzsZBTg5RfbaZ9h/Traveler-selector?node-id=67%3A51
 *
 */
export interface EgdsOpenTravelerSelectorAction extends UiAction {
  __typename: 'EGDSOpenTravelerSelectorAction';
  accessibility?: Maybe<Scalars['String']>;
  analytics: ClientSideAnalytics;
  /** Traveler selector configuration. */
  travelerSelector: EgdsTravelerSelector;
}

/**
 *
 *     Used to define an item contained in a html <select> element.
 *
 */
export interface EgdsOption {
  /** The text visible on screen. */
  label: Scalars['String'];
  /** Default selection for value. */
  selected?: Maybe<Scalars['Boolean']>;
  /** It is associated with label. It corresponds to html option tag value attribute. */
  value: Scalars['String'];
}

/** Ordered variant of EGDS typography list */
export interface EgdsOrderedList extends EgdsElement, EgdsList, EgdsTextList {
  __typename: 'EGDSOrderedList';
  egdsElementId?: Maybe<Scalars['String']>;
  /** @deprecated This field allows for noncompliance to EGDS. Use EGDSTextList instead */
  items: Array<EgdsText>;
  listItems: Array<EgdsTextListItem>;
  size?: Maybe<EgdsTextListSize>;
}

/** Use this button to let users take an alternative, supplemental, or less important action for an overlay button style. */
export interface EgdsOverlayButton extends EgdsButton, EgdsElement {
  __typename: 'EGDSOverlayButton';
  accessibility?: Maybe<Scalars['String']>;
  action?: Maybe<UiLinkAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars['String']>;
}

/** Used to represent a paragraph of text with different EGDS typography styles. */
export interface EgdsParagraph extends EgdsElement, EgdsText {
  __typename: 'EGDSParagraph';
  egdsElementId?: Maybe<Scalars['String']>;
  /** @deprecated Allows for invalid values. Use EGDSParagraphStyle instead */
  size: Scalars['Int'];
  /** Advanced feature. Only need for specific uses. See EGDSParagraphStyle description */
  style: EgdsParagraphStyle;
  text: Scalars['String'];
}

/**
 *
 *     This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 *     Most teams should just use String over EGDSParagraph or EGDSText.
 *
 *     https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 *
 */
export enum EgdsParagraphStyle {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3'
}

/** Represents a password input filed element with autofill property */
export interface EgdsPasswordInputField extends EgdsElement, EgdsInputField {
  __typename: 'EGDSPasswordInputField';
  /** Autofill hint for the input value */
  autofill?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  /** Determines if the input value is visible or obscured */
  passwordVisible?: Maybe<Scalars['Boolean']>;
  placeholder?: Maybe<Scalars['String']>;
  readOnly: Scalars['Boolean'];
  required?: Maybe<Scalars['Boolean']>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars['String']>;
}

/**
 *
 *     Use to toggle on one or more categories (e.g. Beach, Family),
 *     quick-select an option (e.g. quick response in Chat virtual assistant),
 *     or trigger a selection feature (e.g. Datepicker).
 *
 */
export interface EgdsPill {
  accessibility?: Maybe<Scalars['String']>;
  /** Denotes whether pill is in disabled state */
  disabled: Scalars['Boolean'];
  /** Used to denote informative icon */
  icon?: Maybe<UiGraphic>;
  /** Used to uniquely identify a pill */
  id?: Maybe<Scalars['String']>;
  /** Used to display text on pill */
  primary?: Maybe<Scalars['String']>;
  /** Denotes whether pill is in selected state */
  selected: Scalars['Boolean'];
}

/**
 *
 *    Represents Simple plain text
 *
 */
export interface EgdsPlainText extends EgdsText {
  __typename: 'EGDSPlainText';
  /** accessibility text */
  accessibility?: Maybe<Scalars['String']>;
  text: Scalars['String'];
}

/**
 *
 *     Represents a program badge
 *
 *     https://www.figma.com/file/aYQZVH6x5kqAGj8LbLzTVWfX/Badges
 *
 */
export interface EgdsProgramBadge extends EgdsBadge, EgdsElement {
  __typename: 'EGDSProgramBadge';
  accessibility?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  graphic?: Maybe<UiGraphic>;
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  size?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
}

/**
 *
 *     Represents individual radio button. Radio buttons are allow one to be selected out of all of them.
 *
 */
export interface EgdsRadioButton {
  /** Represents the description for the radio button. */
  description?: Maybe<Scalars['String']>;
  /** User cannot interact with the radio when the disabled value is true. */
  disabled: Scalars['Boolean'];
  /** Represents the label description of radio button. Example: 'Label 1', 'Label 2' */
  label: Scalars['String'];
  /** Represents the secondary label of radio button. Example when price associated with radio: '$999' */
  labelSuffix?: Maybe<Scalars['String']>;
  /** Represents the value of the radio button. */
  value: Scalars['String'];
}

/**
 *
 *     Represents collections of radio buttons describing a set of related options.
 *     UITK react:
 *     https://uitk.expedia.biz/expedia/en_US/components/radio-button
 *     Figma:
 *     https://www.figma.com/file/UNXRJ8MDLJjvu7ENZCMhke/Radio-buttons
 *
 */
export interface EgdsRadioGroup {
  /** Represents radio group error message. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Represents the name for the radio group. It will be used as the name for each child radio component. */
  groupName: Scalars['String'];
  /** Represents the heading label of the radio group. */
  label?: Maybe<Scalars['String']>;
  /** Represents options for radio group. */
  options: Array<EgdsRadioButton>;
  /** Represents default selected radio child by passing in its value. */
  selected?: Maybe<Scalars['String']>;
}

/** Specifies that an input has range of input value */
export interface EgdsRangeInputValidation extends EgdsInputValidation {
  __typename: 'EGDSRangeInputValidation';
  errorMessage: Scalars['String'];
  /** Maximum value for the input */
  max: Scalars['Int'];
  /** Minimum value for the input */
  min: Scalars['Int'];
}

/** Specifies a Regex pattern that an input must adhere to */
export interface EgdsRegexInputValidation extends EgdsInputValidation {
  __typename: 'EGDSRegexInputValidation';
  errorMessage: Scalars['String'];
  pattern: Scalars['String'];
}

/** Specifies that an input is required */
export interface EgdsRequiredInputValidation extends EgdsInputValidation {
  __typename: 'EGDSRequiredInputValidation';
  errorMessage: Scalars['String'];
}

/**
 *
 *    Represents implementation of EGDSTravelerSelector which will be used for lodging and packages when selecting room configurations.
 *
 */
export interface EgdsRoomsTravelerSelector extends EgdsElement, EgdsTravelerSelector {
  __typename: 'EGDSRoomsTravelerSelector';
  /** Button to add another room to select travelers for that room. */
  addAnotherRoomButton: EgdsButton;
  closeButton: EgdsButton;
  /** Indicates the done button on the traveler selector. */
  doneButton: EgdsButton;
  egdsElementId?: Maybe<Scalars['String']>;
  /**
   * Represents the infants seat selection module with heading, radio buttons and airline age rule
   * @deprecated Use infantsOnLap and infantsInSeat instead.
   */
  infantSeatSelection?: Maybe<EgdsTravelerInfantSeatSelection>;
  /** Max number of rooms allowed. */
  maxRoomCount?: Maybe<Scalars['Int']>;
  /** Represents list of room configurations for travelers. */
  rooms: Array<EgdsTravelerSelectorRoom>;
  title: Scalars['String'];
  /**
   *
   *         Validations with corresponding error messages to display if the input is invalid.
   *         The order in which the validations appears indicates the order of priority of which error message to display.
   *
   */
  validations?: Maybe<Array<EgdsInputValidation>>;
}

/** Specifies that two inputs can't have the same value */
export interface EgdsSameValueInputValidation extends EgdsInputValidation {
  __typename: 'EGDSSameValueInputValidation';
  errorMessage: Scalars['String'];
}

/**
 *
 *  Action in response to user interaction on search form or search form widget.
 *  Examples include opening up a date picker, launching Typeahead for destination search, and opening Traveler Selector
 *
 */
export type EgdsSearchFormAction = EgdsOpenDatePickerAction | EgdsOpenTravelerSelectorAction | EgdsSearchFormSelectAction | EgdsShowSearchFormAction | EgdsSubmitSearchFormAction | OpenDurationSpanAction | OpenTypeaheadAction;

/** Button found in search form that has a search form specific action once clicked */
export interface EgdsSearchFormButton extends EgdsButton, EgdsElement {
  __typename: 'EGDSSearchFormButton';
  accessibility?: Maybe<Scalars['String']>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  icon?: Maybe<Icon>;
  /** Action to perform when clicked such as submitting the search form. */
  onClick?: Maybe<EgdsSearchFormAction>;
  primary?: Maybe<Scalars['String']>;
  style?: Maybe<EgdsButtonStyle>;
}

/**
 *
 *         Dates field on search form or search form widget for entering a start and end dates
 *
 *         Figma: https://www.figma.com/file/oYtPus1JugVGjib58w8Jkj/E2E-search?node-id=6434%3A270153
 *
 */
export interface EgdsSearchFormDatePickerField extends EgdsElement, EgdsInputField, EgdsSearchFormField {
  __typename: 'EGDSSearchFormDatePickerField';
  action?: Maybe<EgdsSearchFormAction>;
  egdsElementId: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars['String']>;
  readOnly: Scalars['Boolean'];
  required?: Maybe<Scalars['Boolean']>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars['String']>;
}

/**
 *
 *         UI Element used to create and structure a search form
 *         Examples include input fields for selecting date, destination, or travelers, pill groups for selecting LOBs, and containers for organizing the search form into sections
 *
 */
export interface EgdsSearchFormField {
  /** Informs behavior in response to user click */
  action?: Maybe<EgdsSearchFormAction>;
}

/**
 *
 *         Input field on search form or search form widget for entering information such as date, destination, or travelers.
 *
 */
export interface EgdsSearchFormInputField extends EgdsElement, EgdsInputField {
  __typename: 'EGDSSearchFormInputField';
  /** Informs behavior in response to user click. */
  action?: Maybe<EgdsSearchFormAction>;
  egdsElementId: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars['String']>;
  readOnly: Scalars['Boolean'];
  required?: Maybe<Scalars['Boolean']>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars['String']>;
}

/**
 *
 *         Location field on search form or search form widget for entering an origin or destination.
 *
 *         Figma: https://www.figma.com/file/oYtPus1JugVGjib58w8Jkj/E2E-search?node-id=3769%3A204213
 *
 */
export interface EgdsSearchFormLocationField extends EgdsElement, EgdsInputField, EgdsSearchFormField {
  __typename: 'EGDSSearchFormLocationField';
  /** Informs behavior in response to user click on open action */
  action?: Maybe<EgdsSearchFormAction>;
  /** accessibility string in response to user change action */
  changeAccessibility?: Maybe<Scalars['String']>;
  /** Informs behavior in response to user change action */
  changeAnalytics?: Maybe<ClientSideAnalytics>;
  /** accessibility string in response to user click on close action */
  closeAccessibility?: Maybe<Scalars['String']>;
  /** Informs behavior in response to user click on close action */
  closeAnalytics?: Maybe<ClientSideAnalytics>;
  egdsElementId: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  /** @deprecated Use multiLocations */
  locations?: Maybe<Array<Scalars['String']>>;
  /** Multiple locations in case multi-selection field is enabled (typeahead). Commonly used for multiple destinations. */
  multiLocations?: Maybe<Array<EgdsSearchFormSelectedLocation>>;
  placeholder?: Maybe<Scalars['String']>;
  readOnly: Scalars['Boolean'];
  /** Used to tell what regionId is being used for the location */
  regionId?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars['String']>;
}

/** Represents two location fields and allows user to swap values between them by clicking on a swapper button */
export interface EgdsSearchFormLocationsField extends EgdsElement {
  __typename: 'EGDSSearchFormLocationsField';
  /** Destination location field for a search */
  destination: EgdsSearchFormLocationField;
  egdsElementId: Scalars['String'];
  /** Button element for swapping values of origin and destination fields. This button is for Medium and Large viewport where the fields are in line */
  horizontalSwapper?: Maybe<EgdsButton>;
  /** Origin location field for a search */
  origin: EgdsSearchFormLocationField;
  /** Array that contains validations for locations component */
  validations?: Maybe<Array<EgdsInputValidation>>;
  /** Button element for swapping values of origin and destination fields. This button is for Small viewport where origin and destination are stacked */
  verticalSwapper?: Maybe<EgdsButton>;
}

/** Represent a list of elements and allow user to select a single one */
export interface EgdsSearchFormSelectAction {
  __typename: 'EGDSSearchFormSelectAction';
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars['String']>;
  analytics: ClientSideAnalytics;
  /** Field to confirm a user selection */
  apply?: Maybe<EgdsButton>;
  /** Used to provide label value for the form. */
  label?: Maybe<Scalars['String']>;
  /** List of elements available for user selection */
  options: Array<EgdsOption>;
}

export interface EgdsSearchFormSelectedLocation {
  __typename: 'EGDSSearchFormSelectedLocation';
  /**
   *
   *     Informs about the preselected values
   *     Example: \`Hilton\`, \`Hyatt\`, \`Ramada\`
   *
   */
  text: Scalars['String'];
  /**
   *
   *     Optional value or a code associated with the text which can be used to uniquely identify the selection
   *     Example: miami-florida, seattle-washington
   *
   */
  value?: Maybe<Scalars['String']>;
}

/**
 *
 *         Travelers field on search form or search form widget for entering travelers types and count.
 *
 *         Figma: https://www.figma.com/file/oYtPus1JugVGjib58w8Jkj/E2E-search?node-id=3769%3A204213
 *
 */
export interface EgdsSearchFormTravelersField extends EgdsElement, EgdsInputField, EgdsSearchFormField {
  __typename: 'EGDSSearchFormTravelersField';
  action?: Maybe<EgdsSearchFormAction>;
  egdsElementId: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars['String']>;
  readOnly: Scalars['Boolean'];
  required?: Maybe<Scalars['Boolean']>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars['String']>;
}

/** Inputs for search queries such as property search, flights search, etc */
export interface EgdsSearchInputs {
  shoppingSearchCriteria?: Maybe<ShoppingSearchCriteria>;
}

/**
 *
 * Used to structure content.
 * For example: listing all the upcoming trips and then past trips can be achieved with 2 sections.
 *
 */
export interface EgdsSectionContainer extends EgdsElement, EgdsElements {
  __typename: 'EGDSSectionContainer';
  egdsElementId?: Maybe<Scalars['String']>;
  elements: Array<EgdsElement>;
  /** @deprecated Use sectionHeading instead. It allows allows more formatting options. */
  heading?: Maybe<Scalars['String']>;
  sectionHeading?: Maybe<EgdsSectionHeading>;
  /** @deprecated This leads to ambiguity as section themes are not found in EGDS */
  theme?: Maybe<ContainerTheme>;
}

/**
 *
 *     This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 *     Most teams should just use Strings.
 *
 *     Represents a section where the heading and subheading should be placed if they exist
 *
 */
export interface EgdsSectionHeading {
  heading: EgdsHeading;
  subheading?: Maybe<Scalars['String']>;
}

/**
 *
 *     Used for select element with a label, optional icon and option values.
 *     More details on UITK:
 *     http://uitk.expedia.biz/expedia/en_US/components/select
 *     Figma:
 *     https://www.figma.com/file/LvLAeuvgjQAhxUdAVP9Hzk/Selects
 *
 *     The egdsElementId of EGDSElement can be used for 'id' which is further sets 'for' attribute in <label> for accessibility purposes.
 *
 */
export interface EgdsSelect {
  /** User cannot intract with the select when the disabled value is true */
  disabled: Scalars['Boolean'];
  /** Text to be displayed as error text when the select field is in an invalid state. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Icon to render within the select */
  icon?: Maybe<Icon>;
  /** Text for the label element */
  label: Scalars['String'];
  /** Options for select element */
  options: Array<EgdsOption>;
  /** The selected value is displayed in a read only state when readOnly is true */
  readOnly: Scalars['Boolean'];
}

/** Action for showing the search form. */
export interface EgdsShowSearchFormAction {
  __typename: 'EGDSShowSearchFormAction';
  accessibility: Scalars['String'];
  analytics: ClientSideAnalytics;
  icon: Icon;
  /** URI used as a fallback link when website javascript hasn't hydrated. */
  resource: Uri;
}

/**
 *
 *     Date picker for selecting a single date.
 *     Use Case Example: Selecting date for one-way flight.
 *
 */
export interface EgdsSingleDatePicker extends EgdsDatePicker {
  __typename: 'EGDSSingleDatePicker';
  buttonText: Scalars['String'];
  clearButtonText?: Maybe<Scalars['String']>;
  clearDatesButtonAnalytics?: Maybe<ClientSideAnalytics>;
  dateFormat: Scalars['String'];
  datePickerContent?: Maybe<Array<EgdsDatePickerContent>>;
  firstDayOfWeek: EgdsDayName;
  flexibleDateContent?: Maybe<EgdsDatePickerFlexibilityContent>;
  footerText?: Maybe<Scalars['String']>;
  selectedStartDate?: Maybe<Date>;
  showClearDatesButton?: Maybe<Scalars['Boolean']>;
  startDateButtonAnalytics?: Maybe<ClientSideAnalytics>;
  startDatePlaceholderText: Scalars['String'];
  submitButtonAnalytics?: Maybe<ClientSideAnalytics>;
  validDaysLowerBoundInclusive?: Maybe<Date>;
  validDaysUpperBoundInclusive?: Maybe<Date>;
}

/**
 *
 *    This can be used for representing text with inline elements such as stylized text (bold, colored, etc) and/or links.
 *
 */
export interface EgdsSpannableText extends EgdsElement, EgdsText {
  __typename: 'EGDSSpannableText';
  /**
   *
   *     A list of inline EGDSText implementations that comprise the text content.
   *     Example Response: `listOf(EGDSStylizedText("Bold",TextWeight.BOLD), EGDSPlainText(" is for emphasis."))`
   *
   * @deprecated Please use inlineContent
   */
  contents: Array<EgdsText>;
  egdsElementId?: Maybe<Scalars['String']>;
  /**
   *
   *         A list of inline EGDSText implementations that comprise the text content.
   *         Example Response: `listOf(EGDSStylizedText("Bold",TextWeight.BOLD), EGDSPlainText(" is for emphasis."))`
   *
   */
  inlineContent: Array<EgdsSpannableTextItem>;
  /**
   *
   *     The text in its entirety. NO html tags or any other other elements that indicate style should be present.
   *
   */
  text: Scalars['String'];
}

/** List of possible EGDSSpannableText inline implementations */
export type EgdsSpannableTextItem = EgdsGraphicText | EgdsHeading | EgdsInlineLink | EgdsPlainText | EgdsStandardLink | EgdsStylizedText;

/**
 *
 *     Represents a standard badge
 *
 *     https://www.figma.com/file/aYQZVH6x5kqAGj8LbLzTVWfX/Badges
 *
 */
export interface EgdsStandardBadge extends EgdsBadge, EgdsElement {
  __typename: 'EGDSStandardBadge';
  accessibility?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  graphic?: Maybe<UiGraphic>;
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  size?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
}

/**
 *
 *    Represents an EGDS Standard Link
 *    Figma: https://www.figma.com/file/z0DKERbirtEuz6zVMF0HkW/Links?node-id=3206%3A51
 *
 */
export interface EgdsStandardLink extends EgdsElement, EgdsText {
  __typename: 'EGDSStandardLink';
  action: UiLinkAction;
  /** Display disabled link state. */
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  /** Represents an icon next to the link. */
  icon?: Maybe<Icon>;
  /** Display position of the icon next to the link. */
  iconPosition?: Maybe<EgdsIconPosition>;
  /** Display size of the link. */
  size: EgdsLinkSize;
  text: Scalars['String'];
}

/**
 *
 *     Representation of a EGDS message card
 *
 *     https://www.figma.com/file/SRnOSnyVYE5dYh7wEQNIfC/Messaging-card-patterns?node-id=1551%3A1450
 *
 *     UITK component defined at http://uitk.expedia.biz/expedia/en_US/components/menu"
 *
 */
export interface EgdsStandardMessagingCard extends EgdsElement {
  __typename: 'EGDSStandardMessagingCard';
  /** background color for the card */
  background?: Maybe<Scalars['String']>;
  /** list of card buttons */
  buttons?: Maybe<Array<EgdsButton>>;
  /** dismiss action for messaging card */
  dismiss?: Maybe<EgdsDismissAction>;
  egdsElementId?: Maybe<Scalars['String']>;
  /** card graphical item displayed along with body message */
  graphic?: Maybe<UiGraphic>;
  /** card title */
  heading?: Maybe<Scalars['String']>;
  /** impression tracking for messaging card */
  impressionTracking?: Maybe<ClientSideAnalytics>;
  /** list of card links */
  links?: Maybe<Array<EgdsStandardLink>>;
  /** card body text */
  message: Scalars['String'];
  /** right icon for the card */
  rightIcon?: Maybe<Icon>;
  /** represents the card themes such as PADDED, BORDERED */
  themes?: Maybe<Array<EgdsCardThemes>>;
}

/** Represents an EGDS standard submenu */
export interface EgdsStandardSubMenu extends EgdsSubMenu {
  __typename: 'EGDSStandardSubMenu';
  items: Array<EgdsMenuListItem>;
  title?: Maybe<Scalars['String']>;
}

/**
 *
 *     Allows users to increment and decrement a value using controls"
 *     More details on UITK step-input:
 *     http://uitk.expedia.biz/expedia/en_US/components/step-input
 *
 *     Figma:
 *     https://www.figma.com/file/L4BMgfIGUiqx0zM5yBVBxv/Step-inputs
 *
 */
export interface EgdsStepInput {
  /** Screenreader-specific text for the decrease button */
  decreaseText?: Maybe<Scalars['String']>;
  /** Screenreader-specific text for the increase button */
  increaseText?: Maybe<Scalars['String']>;
  /** Unique identifier for the entity which this step input represents. For example, key for "Child" could be "children" */
  key?: Maybe<Scalars['String']>;
  /** Label for the step input */
  label: Scalars['String'];
  /** Maximum value the user can input */
  max?: Maybe<Scalars['Int']>;
  /** Minimum value the user can input */
  min?: Maybe<Scalars['Int']>;
  /** How much the value changes by, per step */
  step: Scalars['Int'];
  /** A small string of subtext underneath the title */
  subLabel?: Maybe<Scalars['String']>;
  /** Initial value for step input. */
  value: Scalars['Int'];
}

/**
 *
 *    Represents stylized text with optional weight, theme and size
 *    https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=7554%3A6533
 *
 */
export interface EgdsStylizedText extends EgdsText {
  __typename: 'EGDSStylizedText';
  /** Use this field when accessibility text needs to be different from text */
  accessibility?: Maybe<Scalars['String']>;
  /** Represents a decorative for the text */
  decorative?: Maybe<EgdsDecorativeText>;
  /** The egds size of this text. http://egds.expedia.biz/latest/tokens/default#foundation-type-size */
  size?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  theme?: Maybe<TextTheme>;
  weight?: Maybe<TextWeight>;
}

/** Represents a EGDS submenu */
export interface EgdsSubMenu {
  /** Represents the array of menu list items */
  items: Array<EgdsMenuListItem>;
  /** Represents the menu title */
  title?: Maybe<Scalars['String']>;
}

/**
 *
 *     Action for submitting search form. This action includes fixed inputs for the search query that are not dependent on what the user entered in the search form.
 *     This action does not include some of the data needed to perform the search query
 *     because the user may have entered that data in other parts of the form after the response that included this action had been received.
 *
 */
export interface EgdsSubmitSearchFormAction extends UiAction {
  __typename: 'EGDSSubmitSearchFormAction';
  accessibility?: Maybe<Scalars['String']>;
  analytics: ClientSideAnalytics;
  /** Query input data that is not dependent on what user entered in the form. */
  fixedInputs?: Maybe<EgdsSearchInputs>;
}

/** Represent a Tab. */
export interface EgdsTab {
  accessibility?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  tabId: Scalars['String'];
}

/** Helps the user easily navigate between related content groups or views. */
export interface EgdsTabs {
  selectedTabId?: Maybe<Scalars['String']>;
  tabs: Array<EgdsTab>;
}

/** Represents the container for the list of template models */
export interface EgdsTemplateModels {
  models: Array<TemplateModel>;
}

/**
 *
 * Implementations may include links, stylized text, or simple text without additional attributes.
 *
 */
export interface EgdsText {
  text: Scalars['String'];
}

/** Represents a large text format input with multiple rows */
export interface EgdsTextAreaInputField extends EgdsElement, EgdsInputField {
  __typename: 'EGDSTextAreaInputField';
  /** Determines if the textarea should be disabled */
  disabled?: Maybe<Scalars['Boolean']>;
  egdsElementId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  /** Sets the max row number the textarea will grow to before scrolling as a user types or pastes in content */
  maxRows?: Maybe<Scalars['Int']>;
  /** Sets the initial number of rows the textarea will accommodate */
  minRows?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Scalars['String']>;
  readOnly: Scalars['Boolean'];
  required?: Maybe<Scalars['Boolean']>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars['String']>;
}

/**
 *
 *     This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 *     Most teams should just use Strings.
 *
 *     Groups text content such as paragraphs.
 *     The first of item of this list may require different spacing than the spacing between items in the list")
 *
 */
export interface EgdsTextContainer {
  contents: Array<EgdsText>;
}

/** EGDS typography list item with link and icon */
export interface EgdsTextIconLinkListItem extends EgdsElement, EgdsText, EgdsTextListItem {
  __typename: 'EGDSTextIconLinkListItem';
  action: UiLinkAction;
  /** Display disabled link state. */
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  icon: Icon;
  /** @deprecated Should not use Recursive datatype. Use custom lists. */
  nestedList?: Maybe<EgdsTextList>;
  /** Display size of the link. */
  size?: Maybe<EgdsLinkSize>;
  style?: Maybe<EgdsTextListItemStyle>;
  subText?: Maybe<Scalars['String']>;
  text: Scalars['String'];
}

/** Icon variant of EGDS typography list */
export interface EgdsTextIconList extends EgdsElement, EgdsTextList {
  __typename: 'EGDSTextIconList';
  egdsElementId?: Maybe<Scalars['String']>;
  listItems: Array<EgdsTextIconListItem>;
  size?: Maybe<EgdsTextListSize>;
}

/** EGDS typography list item with icon */
export interface EgdsTextIconListItem extends EgdsElement, EgdsText, EgdsTextListItem {
  __typename: 'EGDSTextIconListItem';
  /** Hidden text for screen reader accessibility where text and subtext are read on one line */
  accessibilityLabel?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  icon: Icon;
  /** Information for capturing client side impression analytics event */
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  /** Represents the first level of nesting within EGDS List */
  nestedLevelOneList?: Maybe<EgdsNestedLevelOneList>;
  /** @deprecated Should not use Recursive datatype. Use custom lists. */
  nestedList?: Maybe<EgdsTextList>;
  style?: Maybe<EgdsTextListItemStyle>;
  subText?: Maybe<Scalars['String']>;
  text: Scalars['String'];
}

/** Represents a text input filed element with autofill property */
export interface EgdsTextInputField extends EgdsElement, EgdsInputField {
  __typename: 'EGDSTextInputField';
  /** Autofill hint for the input value */
  autofill?: Maybe<Scalars['String']>;
  /** Determines if the text field should be disabled */
  disabled?: Maybe<Scalars['Boolean']>;
  egdsElementId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars['String']>;
  readOnly: Scalars['Boolean'];
  required?: Maybe<Scalars['Boolean']>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars['String']>;
}

/** EGDS compliant typography list https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export interface EgdsTextList {
  listItems: Array<EgdsTextListItem>;
  size?: Maybe<EgdsTextListSize>;
}

/**
 *
 *     This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 *     Most teams should just use Strings.
 *
 *     Contains a text list (i.e. ordered, unordered, bulleted, etc).
 *     Can be used to create a composite text object such as a section containing a heading, list, and footer.
 *
 */
export interface EgdsTextListContainer {
  list: EgdsTextList;
}

/** Typography list item with EGDS styles https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export interface EgdsTextListItem {
  /** @deprecated Should not use Recursive datatype. Use custom lists. */
  nestedList?: Maybe<EgdsTextList>;
  style?: Maybe<EgdsTextListItemStyle>;
  /** Represents the subHeading/subTitle/description of a List Item/Element. */
  subText?: Maybe<Scalars['String']>;
  /** Represents the heading/title of a List Item/Element. */
  text: Scalars['String'];
}

export enum EgdsTextListItemStyle {
  DEFAULT = 'DEFAULT',
  EMPHASIS = 'EMPHASIS',
  LOYALTY = 'LOYALTY',
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}

/**
 *
 *     This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 *     Most teams should just use Strings.
 *
 *     Groups a section of text containing a list
 *
 */
export interface EgdsTextListSection extends EgdsElement, EgdsTextListContainer {
  __typename: 'EGDSTextListSection';
  egdsElementId?: Maybe<Scalars['String']>;
  heading?: Maybe<EgdsSectionHeading>;
  list: EgdsTextList;
}

/** https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export enum EgdsTextListSize {
  LIST_1 = 'LIST_1',
  LIST_2 = 'LIST_2',
  LIST_3 = 'LIST_3'
}

/**
 *  This represents UI variations of EGDS List
 *         figma: https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857
 *
 */
export enum EgdsTextListType {
  BULLET = 'BULLET',
  ICON = 'ICON',
  NO_BULLET = 'NO_BULLET',
  NUMBER = 'NUMBER'
}

/** Represents a EGDS Text menu */
export interface EgdsTextMenu extends EgdsMenu {
  __typename: 'EGDSTextMenu';
  accessibility?: Maybe<Scalars['String']>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  subMenus: Array<EgdsSubMenu>;
  title: Scalars['String'];
}

/**
 *
 *     This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 *     Most teams should just use Strings.
 *
 *     Groups text content and is composed of sections for the heading and body
 *
 */
export interface EgdsTextSection extends EgdsElement, EgdsTextContainer {
  __typename: 'EGDSTextSection';
  contents: Array<EgdsText>;
  egdsElementId?: Maybe<Scalars['String']>;
  heading?: Maybe<EgdsSectionHeading>;
}

/** EGDS typography list item */
export interface EgdsTextStandardListItem extends EgdsElement, EgdsText, EgdsTextListItem {
  __typename: 'EGDSTextStandardListItem';
  /** Hidden text for screen reader accessibility where text and subtext are read on one line */
  accessibilityLabel?: Maybe<Scalars['String']>;
  egdsElementId?: Maybe<Scalars['String']>;
  /** Represents the first level of nesting within EGDS List */
  nestedLevelOneList?: Maybe<EgdsNestedLevelOneList>;
  /** @deprecated Should not use Recursive datatype. Use custom lists. */
  nestedList?: Maybe<EgdsTextList>;
  style?: Maybe<EgdsTextListItemStyle>;
  subText?: Maybe<Scalars['String']>;
  text: Scalars['String'];
}

/** EGDS typography list item with Mark */
export interface EgdsTextWithMarkListItem extends EgdsElement, EgdsText, EgdsTextListItem {
  __typename: 'EGDSTextWithMarkListItem';
  egdsElementId?: Maybe<Scalars['String']>;
  /** EGDS visual assets that do not follow standard sizing to be made icons. */
  mark?: Maybe<Mark>;
  /** @deprecated Should not use Recursive datatype. Use custom lists. */
  nestedList?: Maybe<EgdsTextList>;
  style?: Maybe<EgdsTextListItemStyle>;
  subText?: Maybe<Scalars['String']>;
  text: Scalars['String'];
}

/** Toast notifications are unobstructive window elements used to display quick, auto-expiring messages to users on an action they've taken */
export interface EgdsToast extends EgdsElement {
  __typename: 'EGDSToast';
  button?: Maybe<UiPrimaryButton>;
  egdsElementId?: Maybe<Scalars['String']>;
  text: Scalars['String'];
}

/** Basic Toggle Button element */
export interface EgdsToggleButton {
  __typename: 'EGDSToggleButton';
  /** Accessibility label for the button. */
  accessibility?: Maybe<Scalars['String']>;
  /** Represents whether the button is in disabled state */
  disabled: Scalars['Boolean'];
  /** Element identifier */
  egdsElementId?: Maybe<Scalars['String']>;
  /** Represents icon to be displayed along with label */
  icon?: Maybe<UiGraphic>;
  /** Used as a reference to idenfity on form submit */
  name?: Maybe<Scalars['String']>;
  /** Label to be displayed on the button */
  primary?: Maybe<Scalars['String']>;
  /** Represents the state of the button, if it is selected/deselected */
  selected: Scalars['Boolean'];
  /** analytics event to fire when button is selected */
  selectedAnalytics?: Maybe<ClientSideAnalytics>;
  /** Represents subtext below the label if any */
  subText?: Maybe<Scalars['String']>;
  /** analytics event to fire when button is not selected */
  unselectedAnalytics?: Maybe<ClientSideAnalytics>;
}

/**
 *
 *     Represents collections button toggles to select/deselect one or more options grouped under a single category. They can be used as a visual alternative to checkboxes.
 *
 *     UITK react:
 *     https://uitk.expedia.biz/expedia/en_US/components/button-toggle
 *     Figma:
 *     https://www.figma.com/file/ZLAsPeQr2g6Ze5tTkKrcGk/Button-toggle
 *
 */
export interface EgdsToggleButtonGroup {
  __typename: 'EGDSToggleButtonGroup';
  /** Represents options for toggle button group. */
  options: Array<EgdsToggleButton>;
}

/**
 *
 *    Represents travelers used for traveler selector.
 *
 */
export interface EgdsTraveler {
  /** Represents possible list of ages of traveler. Example: '', '1', '2'....'17'  */
  ages?: Maybe<Array<EgdsSelect>>;
  /** Represents traveler configuration. */
  count: EgdsStepInput;
}

/**
 *
 *    Represents child age selection for traveler selector.
 *
 */
export interface EgdsTravelerChildAgeSelect extends EgdsElement, EgdsSelect {
  __typename: 'EGDSTravelerChildAgeSelect';
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  icon?: Maybe<Icon>;
  label: Scalars['String'];
  /** Localized label with template for child age. Example: 'Child 1 age', 'Child 2 age' */
  labelTemplate: EgdsLocalizedText;
  options: Array<EgdsOption>;
  readOnly: Scalars['Boolean'];
  /** Age value for child. */
  value?: Maybe<Scalars['Int']>;
}

/**
 *
 *    Represents implementation of children for traveler selector.
 *
 */
export interface EgdsTravelerChildren extends EgdsTraveler {
  __typename: 'EGDSTravelerChildren';
  /** Default age selection configuration for child. This template will be used to create new child in the room. */
  ageTemplate: EgdsSelect;
  ages: Array<EgdsSelect>;
  count: EgdsStepInput;
  /**
   * Traveler note to give some info when child is added.
   * @deprecated Please use the one defined in EGDSTravelerSelector or EGDSTravelerSelectorRoom instead.
   */
  travelerNote?: Maybe<Scalars['String']>;
}

/**
 *
 *    Represents implementation of infants for traveler selector.
 *
 */
export interface EgdsTravelerInfant extends EgdsTraveler {
  __typename: 'EGDSTravelerInfant';
  /** Default age selection configuration for infant. This template will be used to create new infant in the room. */
  ageTemplate: EgdsSelect;
  ages: Array<EgdsSelect>;
  count: EgdsStepInput;
  /**
   * Traveler note to give some info when infant is added.
   * @deprecated Please use the one defined in EGDSTravelerSelector or EGDSTravelerSelectorRoom instead.
   */
  travelerNote?: Maybe<Scalars['String']>;
}

/**
 *
 *    Represents infants seat selection for traveler selector.
 *
 */
export interface EgdsTravelerInfantSeatSelection extends EgdsElement, EgdsRadioGroup {
  __typename: 'EGDSTravelerInfantSeatSelection';
  /** Link represent airline rules for infant age selection. */
  airlineAgeRule: EgdsStandardLink;
  egdsElementId?: Maybe<Scalars['String']>;
  errorMessage: Scalars['String'];
  groupName: Scalars['String'];
  /** Label for seat selection options. Example: 'Where will the infant sit?' */
  label: Scalars['String'];
  labelTemplate: EgdsLocalizedText;
  /** Possible options for infants seat. Example: 'In seat', ' On lap'  */
  options: Array<EgdsRadioButton>;
  selected: Scalars['String'];
}

/**
 *
 *    Representation of traveler selector.
 *    The implementation can include travelers or rooms configuration which will be used to select the number of travelers for lodging, flights, packages, cruises and activities.
 *    figma:
 *     https://www.figma.com/file/y59aHUdrzsZBTg5RfbaZ9h/Traveler-selector?node-id=67%3A51
 *
 */
export interface EgdsTravelerSelector {
  /** Close button on the traveler selector. */
  closeButton: EgdsButton;
  /** Done button on the traveler selector. */
  doneButton: EgdsButton;
  /** Title of the traveler selector. Example: Travelers, Travelers in the cabin. */
  title: Scalars['String'];
}

/**
 *
 *    Represents a room in traveler selector. The room will be used to represent hotel room in for lodging and package.
 *
 */
export interface EgdsTravelerSelectorRoom {
  __typename: 'EGDSTravelerSelectorRoom';
  /** Adults configuration for the room. */
  adults: EgdsStepInput;
  /** Children configuration for the room. */
  children: EgdsTraveler;
  /**
   * Infants configuration for the room.
   * @deprecated Use infantsOnLap and infantsInSeat instead.
   */
  infants?: Maybe<EgdsTraveler>;
  /** Represents infant travelers under certain age that require a seat reservation. */
  infantsInSeat?: Maybe<EgdsTraveler>;
  /** Represents infant travelers under certain age that don't require a seat selection. */
  infantsOnLap?: Maybe<EgdsTraveler>;
  /** Label associated with the room. Example: 'Room 1' */
  label: EgdsLocalizedText;
  /** Represent remove room button. Example: 'Remove room' */
  removeRoomButton?: Maybe<EgdsButton>;
  /** Represent extra information to be displayed to the user. Example: 'Letting us know the exact age of your child. */
  travelerNote?: Maybe<EgdsLocalizedText>;
}

/**
 *
 *    Represents implementation of StepInput which will be used for adults, children, infant, seniors count.
 *
 */
export interface EgdsTravelerStepInput extends EgdsElement, EgdsStepInput {
  __typename: 'EGDSTravelerStepInput';
  /**
   * Informs behavior in response to user click.
   * @deprecated Need specific tracking for increase and decrease count event. Hence, deprecating the action and adding new analytics fields for increase and decrease count.
   */
  action?: Maybe<EgdsSearchFormAction>;
  /** Informs behavior in response when user click to decrease travelers count. */
  decreaseAnalytics: ClientSideAnalytics;
  decreaseText?: Maybe<Scalars['String']>;
  /** Localized screen-reader specific text for announcing a decrement in traveler count. Example: 'Decrease the number of adults in room 1' */
  decreaseTextTemplate?: Maybe<EgdsLocalizedText>;
  egdsElementId?: Maybe<Scalars['String']>;
  /** Informs behavior in response when user click to increase travelers count. */
  increaseAnalytics: ClientSideAnalytics;
  increaseText?: Maybe<Scalars['String']>;
  /** Localized screen-reader specific text for announcing an increment in traveler count. Example: 'Increase the number of adults in room 1' */
  increaseTextTemplate?: Maybe<EgdsLocalizedText>;
  key?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  step: Scalars['Int'];
  subLabel?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
}

/** Travelers types used on travelers selector */
export enum EgdsTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT',
  SENIOR = 'SENIOR',
  YOUTH = 'YOUTH'
}

/** Represents all category of travelers used in travelers selector. */
export interface EgdsTravelers {
  __typename: 'EGDSTravelers';
  /** Represents adult travelers. */
  adults: EgdsStepInput;
  /** Represents child travelers. */
  children?: Maybe<EgdsTraveler>;
  /** Represents infant travelers under certain age that require a seat reservation. */
  infantsInSeat?: Maybe<EgdsTraveler>;
  /** Represents infant travelers under certain age that don't require a seat selection. */
  infantsOnLap?: Maybe<EgdsTraveler>;
  /** Represents pets travelers. */
  pets?: Maybe<EgdsCheckBox>;
  /** Represents senior travelers. */
  seniors?: Maybe<EgdsStepInput>;
  /** Represent extra information to be displayed to the user. Example: 'Letting us know the exact age of your child. */
  travelerNote?: Maybe<EgdsLocalizedText>;
}

/**
 *
 *    Used with traveler selector field to specify validations on travelers.
 *
 */
export interface EgdsTravelersInputValidation extends EgdsInputValidation {
  __typename: 'EGDSTravelersInputValidation';
  errorMessage: Scalars['String'];
  /** Component that shows an specific error when travelers are saved */
  errorSummary?: Maybe<EgdsErrorSummary>;
  /** The maximum number of infants in seat allowed for each adult traveler */
  infantsInSeatPerAdult?: Maybe<Scalars['Int']>;
  /** Specifies the maximum count this validation needs. */
  maxCount?: Maybe<Scalars['Int']>;
  /** The minimum age of travelers to carry infant. */
  minAgeToHoldInfant?: Maybe<Scalars['Int']>;
  /** Specifies the type of validation. */
  type: EgdsTravelersValidationType;
}

/** Represents different type of travelers validation. */
export enum EgdsTravelersValidationType {
  /** Used to validate child age required. */
  CHILD_AGE_REQUIRED = 'CHILD_AGE_REQUIRED',
  /** Used to validate maximum number of allowed infants in seat. */
  MANY_INFANT_IN_SEAT = 'MANY_INFANT_IN_SEAT',
  /** Used to validate maximum number of allowed infants on lap. */
  MANY_INFANT_ON_LAP = 'MANY_INFANT_ON_LAP',
  /** Used to validate maximum allowed travelers for search. */
  MAX_TRAVELERS = 'MAX_TRAVELERS'
}

/**
 *
 *         Input field which opens a list of autocomplete selections from the Typeahead API.
 *
 *         More details on UITK:
 *         http://uitk.expedia.biz/expedia/en_US/components/typeahead
 *         Figma:
 *         https://www.figma.com/file/oCe7wGPkh8SU8As0KJ3u2C/Typeahead?node-id=3381%3A0
 *
 */
export interface EgdsTypeaheadInputField extends EgdsElement, EgdsInputField {
  __typename: 'EGDSTypeaheadInputField';
  egdsElementId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars['String']>;
  readOnly: Scalars['Boolean'];
  renderType?: Maybe<EgdsTypeaheadRenderType>;
  required?: Maybe<Scalars['Boolean']>;
  rightIcon?: Maybe<Icon>;
  /** Placeholder text for the typeahead input when no results are found for the query field */
  typeaheadEmptyResultPlaceholder?: Maybe<Scalars['String']>;
  /** Parameters to pass to underlying Typeahead API on client */
  typeaheadInfo: TypeaheadInfo;
  /** Placeholder text for the typeahead input when presented */
  typeaheadPlaceholder?: Maybe<Scalars['String']>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars['String']>;
}

/** Multi select typeahead properties */
export interface EgdsTypeaheadMultiSelect {
  __typename: 'EGDSTypeaheadMultiSelect';
  /** Text for clear all items button text */
  clearAllText?: Maybe<Scalars['String']>;
  /** Specifies is multiple locations selection feature is enable */
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  /** Text to display selected item heading */
  selectedItemHeading?: Maybe<Scalars['String']>;
  /** Flag to show pills for the selected results */
  showPills: Scalars['Boolean'];
}

/** Defines how typeahead results should be displayed on client. */
export enum EgdsTypeaheadRenderType {
  ADAPTIVE = 'ADAPTIVE',
  DIALOG = 'DIALOG',
  MENU = 'MENU'
}

/** Unordered variant of EGDS typography list */
export interface EgdsUnorderedList extends EgdsElement, EgdsList, EgdsTextList {
  __typename: 'EGDSUnorderedList';
  egdsElementId?: Maybe<Scalars['String']>;
  /** @deprecated This field allows for noncompliance to EGDS. Use EGDSTextList instead */
  items: Array<EgdsText>;
  listItems: Array<EgdsTextListItem>;
  size?: Maybe<EgdsTextListSize>;
}

/**
 *
 * Used to specify event type for an interaction.
 * See https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/referrer.json#L26
 *
 */
export enum EgReferrerEventType {
  /** Used to track a click on a UI component. */
  CLICK = 'CLICK',
  /** Used to track an impression of a UI component. */
  IMPRESSION = 'IMPRESSION'
}

/** Used for analytics micro messages, e.g. deals, sponsored */
export interface EgUisMicroMessage {
  __typename: 'EGUisMicroMessage';
  /** Represents message content for the uis prime message as a json. */
  messageContent: Scalars['String'];
  /** Represents name of the uis prime schema. e.g. allHotelProducts, pageIdentity */
  schemaName: Scalars['String'];
}

/**
 * This represents the partner loyalty earn message which is displayed on shopping and checkout pages
 *          for all LOBs - flights, hotels, cars, packages, lx and GT.
 *          This message may include strikethrough points in the earn message in case of a promotional offer
 *          figma - https://www.figma.com/file/AKJp75nU9eqlANpFdKSpip/Earn-Messaging?node-id=19148%3A78180
 *
 */
export interface EarnMessageContainerListItem extends EgdsTextListItem {
  __typename: 'EarnMessageContainerListItem';
  /** Icon/Mark to display the earn message partner logo preceding the message */
  graphic: UiGraphic;
  /** Optional nested Text List */
  nestedList?: Maybe<EgdsTextList>;
  /** Represents the text style used for this item (e.g. Positive, Negative, Emphasis, etc) */
  style?: Maybe<EgdsTextListItemStyle>;
  /** The earn message text which may include strikethrough incase of promotional offers */
  stylizedText?: Maybe<EgdsSpannableText>;
  /** Represents the subHeading/subTitle/description of a List Item */
  subText?: Maybe<Scalars['String']>;
  /** Represents the heading/title of a List Item */
  text: Scalars['String'];
}

/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: Scalars['Int'];
  /** The numeric Abacus ID for an experiment */
  id: Scalars['String'];
}

/** Support for `geo` based URI constructed with latitude, longitude and uncertainty */
export interface GeoUri extends Uri {
  __typename: 'GeoURI';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  uncertainty?: Maybe<Scalars['Int']>;
  value: Scalars['String'];
}

/** Support for `http` or `https` based URI constructed based on a valid `java.net.URL` object. */
export interface HttpUri extends Uri {
  __typename: 'HttpURI';
  relativePath: Scalars['String'];
  value: Scalars['String'];
}

/**
 *
 *     Representation of an Icon and Icon SpotLight
 *     https://www.figma.com/file/Cq6XtgvVIEriWmWmVIMPzNOE/Icons?node-id=6402%3A115
 *
 */
export interface Icon {
  __typename: 'Icon';
  /** The localized text describing the icon */
  description: Scalars['String'];
  /** The egds value used for loading this icon */
  id: Scalars['String'];
  /** The size of the icon */
  size?: Maybe<IconSize>;
  /** The spotlight theme of the icon */
  spotLight?: Maybe<IconSpotLight>;
  /** The theme of the icon */
  theme?: Maybe<IconTheme>;
  /** The localized text describing the title for the icon, mainly used as label in accessibility, such as tooltip */
  title?: Maybe<Scalars['String']>;
  /** The egds id used for loading this icon */
  token: Scalars['String'];
  /** Parameter to show icon with background ellipse or not */
  withBackground?: Maybe<Scalars['Boolean']>;
}

/** supported sizes of icons */
export enum IconSize {
  EXTRA_SMALL = 'EXTRA_SMALL',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  /** @deprecated LARGE icon size changed from 48px to 32px. Use LARGE instead of MEDIUM_LARGE */
  MEDIUM_LARGE = 'MEDIUM_LARGE',
  SMALL = 'SMALL',
  XLARGE = 'XLARGE'
}

/** Supported themes of spotlights. See the prop definitions here: https://www.figma.com/file/Cq6XtgvVIEriWmWmVIMPzNOE/Icons?node-id=6402%3A115 */
export enum IconSpotLight {
  INFO = 'INFO',
  POSITIVE = 'POSITIVE',
  STANDARD = 'STANDARD',
  WARNING = 'WARNING'
}

/** Supported themes of icons. See the prop definitions here: http://uitk-react.tools.expedia.com/expedia/en_US/components/icons */
export enum IconTheme {
  DEFAULT = 'default',
  EMPHASIS = 'emphasis',
  NEGATIVE = 'negative',
  POSITIVE = 'positive'
}

/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: InputMaybe<AuthenticationState>;
  /** The device ID (DUAID) */
  duaid: Scalars['UUID'];
  /** The Expedia User ID */
  expUserId?: InputMaybe<Scalars['String']>;
  /** The user TUID */
  tuid?: InputMaybe<Scalars['String']>;
}

/**
 *
 * A pictorial representation that communicates and illuminates a concept, idea, or process to a user with delight, interest, and beauty.
 * https://www.figma.com/file/PhrzWgeLfR11IxzTZ80ypI/BEX-Illustration
 *
 */
export interface Illustration extends EgdsElement {
  __typename: 'Illustration';
  /** The localized text describing the illustration */
  description: Scalars['String'];
  egdsElementId?: Maybe<Scalars['String']>;
  /** The token name used for loading this illustration */
  id: Scalars['String'];
  /** The location of the illustration pointing to CDN */
  url: Scalars['URL'];
}

export interface Image {
  __typename: 'Image';
  /**
   * Alternate text to be used for accessibility features
   * @deprecated Use description instead
   */
  altText?: Maybe<Scalars['String']>;
  /** Aspect Ratio of the image */
  aspectRatio?: Maybe<AspectRatio>;
  /** The localized text describing the image */
  description: Scalars['String'];
  /** thumbnail image click analytics */
  thumbnailClickAnalytics?: Maybe<ClientSideAnalytics>;
  url: Scalars['URL'];
}


export interface ImageUrlArgs {
  dimensions?: InputMaybe<DimensionsInput>;
}

/** Support for `mailto` based URI constructed based on the email address. */
export interface MailToUri extends Uri {
  __typename: 'MailToURI';
  emailAddress: Scalars['String'];
  value: Scalars['String'];
}

/** EGDS visual assets that do not follow standard sizing to be made icons */
export interface Mark {
  __typename: 'Mark';
  /** The localized text describing the mark */
  description: Scalars['String'];
  /** The egds value used for loading this mark */
  id: Scalars['String'];
  /** The egds orientation of this mark */
  orientation?: Maybe<Orientation>;
  /** The egds size of this mark */
  size?: Maybe<Scalars['String']>;
  /** The egds id used for loading this mark */
  token: Scalars['String'];
  /** The image source URL for loading this mark */
  url?: Maybe<HttpUri>;
}

/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValue {
  __typename: 'NumberValue';
  id: Scalars['String'];
  value: Scalars['Int'];
}

/**
 *
 *     Action for opening the duration span element.
 *     figma: https://www.figma.com/file/eiXu9ARV67TsK58GPfKdku/Cruise-search-(CSR)?node-id=2905%3A161931
 *
 */
export interface OpenDurationSpanAction {
  __typename: 'OpenDurationSpanAction';
  /** Message for accessibility purposes on duration span action completion. */
  accessibility?: Maybe<Scalars['String']>;
  /** Captures client side analytics events for the duration span element. */
  analytics: ClientSideAnalytics;
  /** Configuration for the duration span element. */
  durationSpan: DurationSpan;
}

/**
 *
 * Open a typeahead dialog
 * https://www.figma.com/file/oCe7wGPkh8SU8As0KJ3u2C/Typeahead
 *
 */
export interface OpenTypeaheadAction extends UiAction {
  __typename: 'OpenTypeaheadAction';
  accessibility?: Maybe<Scalars['String']>;
  /**
   * Enables exact search term matching
   * @deprecated Use info.allowExactMatch
   */
  allowExactMatch: Scalars['Boolean'];
  analytics: ClientSideAnalytics;
  /**
   * Flag used to categorize the typeahead results
   * @deprecated Use info.categorize
   */
  categorize: Scalars['Boolean'];
  /**
   * Text for clear all items button text
   * @deprecated Use info.typeaheadMultiSelect.clearAllText
   */
  clearAllText?: Maybe<Scalars['String']>;
  /**
   * Text for dismiss button text
   * @deprecated Use info.dismissButtonText
   */
  dismissButtonText?: Maybe<Scalars['String']>;
  /**
   * Placeholder for using when no results have been gather, commonly displayed when user hasn't performed a search before
   * @deprecated Use info.emptyResultsPlaceholder
   */
  emptyResultsPlaceholder?: Maybe<Scalars['String']>;
  info: TypeaheadInfo;
  /**
   * When this flag is set, the heading for the categorized results is shown
   * @deprecated Use info.listTitle
   */
  listTitle: Scalars['Boolean'];
  /**
   * Text to display selected item heading
   * @deprecated Use info.typeaheadMultiSelect.selectedItemHeading
   */
  selectedItemHeading?: Maybe<Scalars['String']>;
  /**
   * Flag to show pills for the selected results
   * @deprecated Use info.typeaheadMultiSelect.showPills
   */
  showPills: Scalars['Boolean'];
}

/** Possible values for UITK mark's orientation prop */
export enum Orientation {
  /** Landscape orientation */
  LANDSCAPE = 'LANDSCAPE',
  /** Portrait orientation */
  PORTRAIT = 'PORTRAIT'
}

/**
 *
 *     Languages vary in how they handle plurals of nouns or unit expressions ("hour" vs "hours", and so on).
 *     Some languages have two forms, like English; some languages have only a single form; and some languages have multiple forms. CLDR uses short, mnemonic tags for these plural categories.
 *     http://cldr.unicode.org/index/cldr-spec/plural-rules
 *
 */
export enum PluralCategory {
  FEW = 'FEW',
  MANY = 'MANY',
  ONE = 'ONE',
  OTHER = 'OTHER',
  TWO = 'TWO',
  ZERO = 'ZERO'
}

/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = 'CAN_NOT_TRACK',
  CAN_TRACK = 'CAN_TRACK'
}

export interface Query {
  __typename: 'Query';
  _service: _Service;
  /** Top-level query to serve a documentation experience */
  documentation: Documentation;
}


export interface QueryDocumentationArgs {
  context: ContextInput;
  hubId: Scalars['String'];
}

/** Type used during a product search to specify a given numeric range like the price of a hotel should be between 100 and 200 (USD). */
export interface RangeValue {
  __typename: 'RangeValue';
  id: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
}

/**
 *
 *     Range field on search form or search form widget for entering an event duration.
 *
 *     Figma: https://www.figma.com/file/eiXu9ARV67TsK58GPfKdku/Cruise-search-(CSR)?node-id=2486%3A154892
 *
 */
export interface SearchFormDurationSpanField extends EgdsElement, EgdsInputField, EgdsSearchFormField {
  __typename: 'SearchFormDurationSpanField';
  /**
   *
   *         Used for screen readers to inform about the current value.
   *         Example: based on a display value "3 - 9 nights", read "3 to 9 nights".
   *
   */
  accessibilityTemplate?: Maybe<EgdsLocalizedText>;
  /** Informs behavior in response to user click. */
  action?: Maybe<EgdsSearchFormAction>;
  /**
   *
   *         Element unique identifier. Uses include handling diffs for UI updates
   *         and identifying the source of data for user input fields.
   *
   */
  egdsElementId: Scalars['String'];
  /** Text to be displayed as error text when the input field is in an invalid state. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Provides detailed instructions to the user on how to use the input element. */
  instructions?: Maybe<Scalars['String']>;
  /** Tag description for the input element. */
  label?: Maybe<Scalars['String']>;
  /**
   *
   *         Used to dynamically update the label text in the client, based on user interaction with the input.
   *
   */
  labelTemplate?: Maybe<EgdsLocalizedText>;
  /** Icon positioned to the left side of the input element. */
  leftIcon?: Maybe<Icon>;
  /** Description of the expected value for the input element. */
  placeholder?: Maybe<Scalars['String']>;
  /** Field is in a read-only state displaying only text when readOnly is true. */
  readOnly: Scalars['Boolean'];
  /** Informs the user if the field is mandatory. */
  required?: Maybe<Scalars['Boolean']>;
  /** Icon positioned to the right side of the input element. */
  rightIcon?: Maybe<Icon>;
  /**
   *
   *         Validations with corresponding error messages to display if the input is invalid.
   *         The order in which the validations appears indicates the order of priority of which error message to display.
   *
   */
  validations?: Maybe<Array<EgdsInputValidation>>;
  /** Default value for the input element. */
  value?: Maybe<Scalars['String']>;
}

/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValue {
  __typename: 'SelectedValue';
  id: Scalars['String'];
  value: Scalars['String'];
}

/** Support for creating self referenced links by prefixing fragments with (#) */
export interface SelfReferencedUri extends Uri {
  __typename: 'SelfReferencedURI';
  fragment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
}

/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteria {
  __typename: 'ShoppingSearchCriteria';
  booleans?: Maybe<Array<BooleanValue>>;
  counts?: Maybe<Array<NumberValue>>;
  dates?: Maybe<Array<DateValue>>;
  ranges?: Maybe<Array<RangeValue>>;
  selections?: Maybe<Array<SelectedValue>>;
}

/** Used to describe an action on Sort and Filter Modal. */
export interface ShoppingSortAndFilterAction extends UiAction {
  __typename: 'ShoppingSortAndFilterAction';
  accessibility?: Maybe<Scalars['String']>;
  actionType: ShoppingSortAndFilterActionType;
  analytics: ClientSideAnalytics;
}

/** Valid actions on Sort and Filter Modal */
export enum ShoppingSortAndFilterActionType {
  /** Stay on the Sort & Filter Modal but set to default state. Eg used for clear button */
  CLEAR_DATA = 'CLEAR_DATA',
  /** Close Sort & Filter Modal and apply user selected filters. Eg used for Apply/Done buttons */
  CLOSE_AND_APPLY = 'CLOSE_AND_APPLY',
  /** Close Sort & Filter Modal. Eg used for Back/Cross buttons */
  CLOSE_AND_DO_NOT_APPLY = 'CLOSE_AND_DO_NOT_APPLY',
  /**
   *
   *     Open the modal window associated with the component on which action has been performed.
   *     Example: on click of Sort & Filter reveal button it should open Sort & Filter Modal and
   *            on click of Input Field it should open Typeahead Modal
   *
   */
  OPEN_MODAL = 'OPEN_MODAL'
}

export interface SuggestionForm {
  __typename: 'SuggestionForm';
  /** Suggestion form input */
  input: EgdsTextInputField;
  /** Suggestion from submit button */
  submit: UiPrimaryButton;
  /** Suggestion form thank you message. */
  thankYouMessage: EgdsPlainText;
}

/** Support for `tel` based URI constructed based on the phone number. */
export interface TelUri extends Uri {
  __typename: 'TelURI';
  phoneNumber: Scalars['String'];
  value: Scalars['String'];
}

/**
 *
 *     Represents the dynamic part of the localized text.  The `key` value indicates where to insert the variable data.
 *     The `source` is an ID for locating the actual data that will be inserted.
 *
 */
export interface TemplateModel {
  __typename: 'TemplateModel';
  key: Scalars['String'];
  source: Scalars['String'];
}

/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export enum TextTheme {
  EMPHASIS = 'EMPHASIS',
  INVERSE = 'INVERSE',
  LOYALTY = 'LOYALTY',
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export enum TextWeight {
  BOLD = 'BOLD',
  MEDIUM = 'MEDIUM',
  REGULAR = 'REGULAR'
}

/**
 *
 *     Used to setup UITK Typeahead component (which internally uses Expedia Suggest Service API)
 *     enables search resolution functionalities
 *
 *     More details on UITK Typeahead:
 *     https://uitk.expedia.biz/expedia/en_US/components/typeahead
 *
 */
export interface TypeaheadInfo {
  __typename: 'TypeaheadInfo';
  /** Enables exact search term matching */
  allowExactMatch: Scalars['Boolean'];
  /** Flag used to categorize the typeahead results */
  categorize: Scalars['Boolean'];
  /** An agreed upon name between Expedia Suggest Service and its partners */
  client?: Maybe<Scalars['String']>;
  /** Text for dismiss button text */
  dismissButtonText?: Maybe<Scalars['String']>;
  /** Specify the domain to use for the requests, ex `www.expedia.com` */
  domain?: Maybe<Scalars['String']>;
  /** When set to true, nearby results will be presented when the user focuses the destination input without typing anything */
  drivable: Scalars['Boolean'];
  /** Placeholder for using when no results have been gather, commonly displayed when user hasn't performed a search before */
  emptyResultsPlaceholder?: Maybe<Scalars['String']>;
  /**
   *
   *         Specifies whether query term is a destination (as opposed to an origin).
   *         ESS needs this information for Flights/Packages/Cars.
   *
   */
  isDestination: Scalars['Boolean'];
  /**
   * Specifies is multiple locations selection feature is enable
   * @deprecated Use typeaheadMultiSelect.isMultiLocation
   */
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  /** One of the Expedia Group line of business: Hotels, Flights, Cars, Packages... */
  lineOfBusiness?: Maybe<Scalars['String']>;
  /** When this flag is set, the heading for the categorized results is shown */
  listTitle: Scalars['Boolean'];
  /** Specifies the maximum number of results to be returned in ESS response */
  maxNumberOfResults?: Maybe<Scalars['Int']>;
  /** Package type, this parameter accompanies Packages line of business */
  packageType?: Maybe<Scalars['String']>;
  /** When set to true, user history is considered while compiling results */
  personalize: Scalars['Boolean'];
  /** Used to fetch results from within the specified region id */
  regionId?: Maybe<Scalars['String']>;
  /** Region category, eg: Airport, City, Multi-city... */
  regionType?: Maybe<Scalars['Int']>;
  /** When set to true, the current location option will be displayed when Typeahead is open */
  showCurrentLocation?: Maybe<Scalars['Boolean']>;
  /** When set to true, trending results will be presented when the user focuses the destination input without typing anything */
  trending: Scalars['Boolean'];
  /** Features enabled, such as ta_hierarchy enables that typeahead shows the hierarchy */
  typeaheadFeatures?: Maybe<Scalars['String']>;
  /** Property to use for multi select option */
  typeaheadMultiSelect?: Maybe<EgdsTypeaheadMultiSelect>;
}

/**
 *
 * An action is a generic container to information the client side application what can be done with a given card.
 * Sometimes the action will be could be associated with a deep link, opening a specific view or leveraging some protocols like e-mails or phones.
 * Every action must be trackable for analytics purpose based on the `analytics` information.
 *
 */
export interface UiAction {
  /**
   *
   *       Used to provide accessibility that has to be read on completion of action.
   *
   */
  accessibility?: Maybe<Scalars['String']>;
  analytics: ClientSideAnalytics;
}

/** Banners are used to notify users of an urgent or important condition that may affect their trip or booking experience. */
export interface UiBanner extends EgdsElement {
  __typename: 'UIBanner';
  actions: Array<UiLinkAction>;
  egdsElementId?: Maybe<Scalars['String']>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  heading?: Maybe<Scalars['String']>;
  icon?: Maybe<Icon>;
  message: Scalars['String'];
  theme?: Maybe<Scalars['String']>;
}

/**
 *
 *     Empty state elements are provided as separate pieces that combine to form different variations and can be assembled in a variety of different ways depending on need.
 *     Empty states can be used between modules on a page or be placed alone in a full screen view.
 *     Figma: https://www.figma.com/file/0OuX8BMSFmFdWYXfdCEjrj/Empty-state
 *
 */
export interface UiEmptyState extends EgdsElement {
  __typename: 'UIEmptyState';
  body: Scalars['String'];
  egdsElementId?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  icon?: Maybe<Icon>;
  primaryButton?: Maybe<UiPrimaryButton>;
  tertiaryButton?: Maybe<UiTertiaryButton>;
}

/** Use this button for a floating icon style. */
export interface UiFloatingActionButton {
  accessibility?: Maybe<Scalars['String']>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  /** Used to capture client side analytics on button click. */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Use badge to notify a count on button. */
  badge?: Maybe<Scalars['Int']>;
  disabled: Scalars['Boolean'];
  icon?: Maybe<Icon>;
  /** Use primary to show text beside icon or badge. */
  primary?: Maybe<Scalars['String']>;
}

/**
 *
 * In many cases, UX designs support Icons, Illustrations, and Marks interchangeably.
 * Their fields are slightly different and their UI implementations are also different.
 * Graphic is intended to help group those possible types together without having to add nullable fields for them individually.
 *
 */
export type UiGraphic = Icon | Illustration | Mark;

/**
 *
 * Used to describe a URI based link. A URI can expose several protocols like `geo` for geographical information, `tel` to let the customer's phone application taking over or even `mailto`.
 *
 */
export interface UiLinkAction extends UiAction {
  __typename: 'UILinkAction';
  accessibility?: Maybe<Scalars['String']>;
  analytics: ClientSideAnalytics;
  resource: Uri;
  target: UiLinkTarget;
  /** Flag to identify if relative path to be rendered or whole url */
  useRelativePath: Scalars['Boolean'];
}

/** Specifies whether to open the link in the same user interface context or in a different context */
export enum UiLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

/**
 *
 *     A specific type of card used for product messaging or other contextual information highlighted to the user.
 *     This is often used for things like product availability, user sign-in status, earning brand points, or other promotional/informative messages.
 *     Figma: https://www.figma.com/file/V9juOKAE4bgugBqxRiPBjJ/Messaging-cards
 *
 */
export interface UiMessagingCard extends EgdsElement {
  __typename: 'UIMessagingCard';
  actions?: Maybe<UiMessagingCardActions>;
  egdsElementId?: Maybe<Scalars['String']>;
  graphic?: Maybe<UiGraphic>;
  primary?: Maybe<Scalars['String']>;
  secondaries?: Maybe<Array<Scalars['String']>>;
}

/**
 *
 *     There are times when a Messaging Card can provide some actionable options to the user.
 *     For visual consistency, the targets/triggers for those actions should be limited to Button types.
 *     Common examples of Messaging Card Actions could be "Sign-in", "Show me FooBar properties", "Learn more".
 *
 */
export interface UiMessagingCardActions {
  __typename: 'UIMessagingCardActions';
  primary?: Maybe<UiTertiaryButton>;
  secondaries?: Maybe<Array<UiTertiaryButton>>;
}

/** Use this button to make the primary call to action. Do not use it for different calls to action in the same view. */
export interface UiPrimaryButton extends EgdsButton, EgdsElement {
  __typename: 'UIPrimaryButton';
  accessibility?: Maybe<Scalars['String']>;
  action?: Maybe<UiAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars['String']>;
}

/** Use this button to make the primary call to action and for a floating button style. */
export interface UiPrimaryFloatingActionButton extends EgdsElement, UiFloatingActionButton {
  __typename: 'UIPrimaryFloatingActionButton';
  accessibility?: Maybe<Scalars['String']>;
  action?: Maybe<UiAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  badge?: Maybe<Scalars['Int']>;
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars['String']>;
}

/** Use this button to let users take an alternative, supplemental, or less important action. */
export interface UiSecondaryButton extends EgdsButton, EgdsElement {
  __typename: 'UISecondaryButton';
  accessibility?: Maybe<Scalars['String']>;
  action?: Maybe<UiAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars['String']>;
}

/** Use this button to let users take an alternative, supplemental, or less important action and for a floating icon style. */
export interface UiSecondaryFloatingActionButton extends EgdsElement, UiFloatingActionButton {
  __typename: 'UISecondaryFloatingActionButton';
  accessibility?: Maybe<Scalars['String']>;
  action?: Maybe<UiAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  badge?: Maybe<Scalars['Int']>;
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars['String']>;
}

/** Use this button for the least amount of prominence. */
export interface UiTertiaryButton extends EgdsButton, EgdsElement {
  __typename: 'UITertiaryButton';
  accessibility?: Maybe<Scalars['String']>;
  action?: Maybe<UiAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars['Boolean'];
  egdsElementId?: Maybe<Scalars['String']>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars['String']>;
}

/**
 * Generic representation of a Uniform Resource Indicator see [RFC](https://tools.ietf.org/html/rfc3986) for more information.
 * Example of use case:
 * - non http protocol: being able to expose a link like `tel` to let the mobile native integration taking over to call the hotelier.
 * - http protocol: being able to retrieve relative URL (path + query + fragment)
 *
 */
export interface Uri {
  value: Scalars['String'];
}

export interface _Service {
  __typename: '_Service';
  sdl: Scalars['String'];
}

export type CustomerSurveyLinkFragment = { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } };

export type CustomerSurveyButtonFragment = { __typename: 'UIPrimaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null, icon?: { __typename: 'Icon', token: string } | null };

export type CustomerSurveyFragment = { __typename: 'DocumentationCustomerSurveyResponse', button: { __typename: 'EGDSOverlayButton' } | { __typename: 'EGDSSearchFormButton' } | { __typename: 'UIPrimaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null, icon?: { __typename: 'Icon', token: string } | null } | { __typename: 'UISecondaryButton' } | { __typename: 'UITertiaryButton' } };

export type CustomerSurveyQueryVariables = Exact<{
  hubId: Scalars['String'];
  context: ContextInput;
}>;


export type CustomerSurveyQuery = { __typename: 'Query', documentation: { __typename: 'Documentation', customerSurvey: { __typename: 'DocumentationCustomerSurveyResponse', button: { __typename: 'EGDSOverlayButton' } | { __typename: 'EGDSSearchFormButton' } | { __typename: 'UIPrimaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null, icon?: { __typename: 'Icon', token: string } | null } | { __typename: 'UISecondaryButton' } | { __typename: 'UITertiaryButton' } } } };

export type BreadcrumbLinkFragment = { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } };

export type BreadcrumbTextFragment = { __typename: 'EGDSStylizedText', text: string };

export type DocumentDataFragment = { __typename: 'DocumentationDocumentSuccessResponse', content: string, intro?: string | null, title: string, thumbnail: { __typename: 'Image', url: any }, banner?: { __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null } | null, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null, navigationTrail?: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } } | { __typename: 'EGDSStylizedText', text: string } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }> | null };

export type DocumentErrorActionFragment = { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } };

export type DocumentErrorFragment = { __typename: 'DocumentationDocumentErrorResponse', notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null, messageText: { __typename: 'EGDSPlainText', text: string }, descriptionText: { __typename: 'EGDSPlainText', text: string }, buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null, action?: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UISecondaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UITertiaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null }> };

export type DocumentQueryVariables = Exact<{
  hubId: Scalars['String'];
  documentId: Scalars['String'];
  context: ContextInput;
}>;


export type DocumentQuery = { __typename: 'Query', documentation: { __typename: 'Documentation', document: { __typename: 'DocumentationDocumentErrorResponse', notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null, messageText: { __typename: 'EGDSPlainText', text: string }, descriptionText: { __typename: 'EGDSPlainText', text: string }, buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null, action?: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UISecondaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UITertiaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null }> } | { __typename: 'DocumentationDocumentRedirect' } | { __typename: 'DocumentationDocumentSuccessResponse', content: string, intro?: string | null, title: string, thumbnail: { __typename: 'Image', url: any }, banner?: { __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null } | null, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null, navigationTrail?: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } } | { __typename: 'EGDSStylizedText', text: string } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }> | null } } };

export type ReactionButtonFragment = { __typename: 'UIPrimaryButton', primary?: string | null, icon?: { __typename: 'Icon', title?: string | null, token: string, size?: IconSize | null } | null };

export type ReactionFormFragment = { __typename: 'SuggestionForm', input: { __typename: 'EGDSTextInputField', label: string, placeholder?: string | null, validations?: Array<{ __typename: 'DurationSpanInputValidation', errorMessage: string } | { __typename: 'EGDSMaxLengthInputValidation', errorMessage: string } | { __typename: 'EGDSMinLengthInputValidation', errorMessage: string } | { __typename: 'EGDSRangeInputValidation', errorMessage: string } | { __typename: 'EGDSRegexInputValidation', errorMessage: string } | { __typename: 'EGDSRequiredInputValidation', errorMessage: string } | { __typename: 'EGDSSameValueInputValidation', errorMessage: string } | { __typename: 'EGDSTravelersInputValidation', errorMessage: string }> | null }, submit: { __typename: 'UIPrimaryButton', primary?: string | null }, thankYouMessage: { __typename: 'EGDSPlainText', text: string } };

export type FeedbackQueryVariables = Exact<{
  hubId: Scalars['String'];
  context: ContextInput;
}>;


export type FeedbackQuery = { __typename: 'Query', documentation: { __typename: 'Documentation', feedback: { __typename: 'DocumentationFeedbackResponse', question: { __typename: 'EGDSPlainText', text: string }, suggestionForm: { __typename: 'SuggestionForm', input: { __typename: 'EGDSTextInputField', label: string, placeholder?: string | null, validations?: Array<{ __typename: 'DurationSpanInputValidation', errorMessage: string } | { __typename: 'EGDSMaxLengthInputValidation', errorMessage: string } | { __typename: 'EGDSMinLengthInputValidation', errorMessage: string } | { __typename: 'EGDSRangeInputValidation', errorMessage: string } | { __typename: 'EGDSRegexInputValidation', errorMessage: string } | { __typename: 'EGDSRequiredInputValidation', errorMessage: string } | { __typename: 'EGDSSameValueInputValidation', errorMessage: string } | { __typename: 'EGDSTravelersInputValidation', errorMessage: string }> | null }, submit: { __typename: 'UIPrimaryButton', primary?: string | null }, thankYouMessage: { __typename: 'EGDSPlainText', text: string } }, thumpsDown: { __typename: 'UIPrimaryButton', primary?: string | null, icon?: { __typename: 'Icon', title?: string | null, token: string, size?: IconSize | null } | null }, thumpsUp: { __typename: 'UIPrimaryButton', primary?: string | null, icon?: { __typename: 'Icon', title?: string | null, token: string, size?: IconSize | null } | null }, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null } } };

export type HeaderLinkFragment = { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } };

export type HeaderLogoFragment = { __typename: 'DocumentationHeaderLogoElement', altText: string, imgSrc: { __typename: 'Image', url: any, description: string } };

type HeaderElement_DocumentationHeaderLogoElement_Fragment = { __typename: 'DocumentationHeaderLogoElement', altText: string, imgSrc: { __typename: 'Image', url: any, description: string } };

type HeaderElement_EgdsStandardLink_Fragment = { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } };

export type HeaderElementFragment = HeaderElement_DocumentationHeaderLogoElement_Fragment | HeaderElement_EgdsStandardLink_Fragment;

export type LanguageItemFragment = { __typename: 'DocumentationHeaderMenuLinkItem', title: string, label: string, action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string } | null };

export type SearchBoxFragment = { __typename: 'DocumentationHeaderSearchBoxElement', placeholder: string, icon: { __typename: 'Icon', title?: string | null, description: string, size?: IconSize | null, id: string, token: string }, indexFileUri: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } };

export type LanguageMenuFragment = { __typename: 'DocumentationMenu', subMenus: Array<{ __typename: 'DocumentationHeaderSubMenu', items: Array<{ __typename: 'DocumentationHeaderMenuLinkItem', title: string, label: string, action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string } | null } | { __typename: 'EGDSMenuListIconTextItem' } | { __typename: 'EGDSMenuStandardItem' } | { __typename: 'EGDSMenuTextItem' }> } | { __typename: 'EGDSStandardSubMenu' }>, leadingIcon?: { __typename: 'Icon', token: string } | null, trailingIcon?: { __typename: 'Icon', token: string } | null };

export type AuthenticationLinkFragment = { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } };

export type AuthenticationFragment = { __typename: 'Authentication', menu?: { __typename: 'AuthenticatedUserMenu', title: string, icon?: { __typename: 'Icon', token: string } | null, buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UISecondaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UITertiaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null }>, subMenus: Array<{ __typename: 'DocumentationHeaderSubMenu', title?: string | null, items: Array<{ __typename: 'DocumentationHeaderMenuLinkItem', title: string, action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } } | { __typename: 'EGDSMenuListIconTextItem', title: string } | { __typename: 'EGDSMenuStandardItem', title: string, icon?: { __typename: 'Icon', token: string } | null } | { __typename: 'EGDSMenuTextItem', title: string }> } | { __typename: 'EGDSStandardSubMenu', title?: string | null, items: Array<{ __typename: 'DocumentationHeaderMenuLinkItem', title: string, action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } } | { __typename: 'EGDSMenuListIconTextItem', title: string } | { __typename: 'EGDSMenuStandardItem', title: string, icon?: { __typename: 'Icon', token: string } | null } | { __typename: 'EGDSMenuTextItem', title: string }> }> } | null, buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UISecondaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UITertiaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null }> };

export type DocumentationHeaderFragment = { __typename: 'DocumentationHeaderResponse', hubName: string, logo: { __typename: 'DocumentationHeaderLogoElement', altText: string, imgSrc: { __typename: 'Image', url: any, description: string } }, primaryNavigation: Array<{ __typename: 'DocumentationHeaderLogoElement', altText: string, imgSrc: { __typename: 'Image', url: any, description: string } } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } }>, secondaryNavigation: Array<{ __typename: 'DocumentationHeaderLogoElement', altText: string, imgSrc: { __typename: 'Image', url: any, description: string } } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } }>, searchBox: { __typename: 'DocumentationHeaderSearchBoxElement', placeholder: string, icon: { __typename: 'Icon', title?: string | null, description: string, size?: IconSize | null, id: string, token: string }, indexFileUri: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, languageMenu: { __typename: 'AuthenticatedUserMenu' } | { __typename: 'DocumentationMenu', subMenus: Array<{ __typename: 'DocumentationHeaderSubMenu', items: Array<{ __typename: 'DocumentationHeaderMenuLinkItem', title: string, label: string, action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string } | null } | { __typename: 'EGDSMenuListIconTextItem' } | { __typename: 'EGDSMenuStandardItem' } | { __typename: 'EGDSMenuTextItem' }> } | { __typename: 'EGDSStandardSubMenu' }>, leadingIcon?: { __typename: 'Icon', token: string } | null, trailingIcon?: { __typename: 'Icon', token: string } | null } | { __typename: 'EGDSGraphicMenu' } | { __typename: 'EGDSTextMenu' }, authentication: { __typename: 'Authentication', menu?: { __typename: 'AuthenticatedUserMenu', title: string, icon?: { __typename: 'Icon', token: string } | null, buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UISecondaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UITertiaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null }>, subMenus: Array<{ __typename: 'DocumentationHeaderSubMenu', title?: string | null, items: Array<{ __typename: 'DocumentationHeaderMenuLinkItem', title: string, action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } } | { __typename: 'EGDSMenuListIconTextItem', title: string } | { __typename: 'EGDSMenuStandardItem', title: string, icon?: { __typename: 'Icon', token: string } | null } | { __typename: 'EGDSMenuTextItem', title: string }> } | { __typename: 'EGDSStandardSubMenu', title?: string | null, items: Array<{ __typename: 'DocumentationHeaderMenuLinkItem', title: string, action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } } | { __typename: 'EGDSMenuListIconTextItem', title: string } | { __typename: 'EGDSMenuStandardItem', title: string, icon?: { __typename: 'Icon', token: string } | null } | { __typename: 'EGDSMenuTextItem', title: string }> }> } | null, buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UISecondaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UITertiaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null }> }, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null };

export type HeaderQueryVariables = Exact<{
  hubId: Scalars['String'];
  context: ContextInput;
}>;


export type HeaderQuery = { __typename: 'Query', documentation: { __typename: 'Documentation', header: { __typename: 'DocumentationHeaderResponse', hubName: string, logo: { __typename: 'DocumentationHeaderLogoElement', altText: string, imgSrc: { __typename: 'Image', url: any, description: string } }, primaryNavigation: Array<{ __typename: 'DocumentationHeaderLogoElement', altText: string, imgSrc: { __typename: 'Image', url: any, description: string } } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } }>, secondaryNavigation: Array<{ __typename: 'DocumentationHeaderLogoElement', altText: string, imgSrc: { __typename: 'Image', url: any, description: string } } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } }>, searchBox: { __typename: 'DocumentationHeaderSearchBoxElement', placeholder: string, icon: { __typename: 'Icon', title?: string | null, description: string, size?: IconSize | null, id: string, token: string }, indexFileUri: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, languageMenu: { __typename: 'AuthenticatedUserMenu' } | { __typename: 'DocumentationMenu', subMenus: Array<{ __typename: 'DocumentationHeaderSubMenu', items: Array<{ __typename: 'DocumentationHeaderMenuLinkItem', title: string, label: string, action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string } | null } | { __typename: 'EGDSMenuListIconTextItem' } | { __typename: 'EGDSMenuStandardItem' } | { __typename: 'EGDSMenuTextItem' }> } | { __typename: 'EGDSStandardSubMenu' }>, leadingIcon?: { __typename: 'Icon', token: string } | null, trailingIcon?: { __typename: 'Icon', token: string } | null } | { __typename: 'EGDSGraphicMenu' } | { __typename: 'EGDSTextMenu' }, authentication: { __typename: 'Authentication', menu?: { __typename: 'AuthenticatedUserMenu', title: string, icon?: { __typename: 'Icon', token: string } | null, buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UISecondaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UITertiaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null }>, subMenus: Array<{ __typename: 'DocumentationHeaderSubMenu', title?: string | null, items: Array<{ __typename: 'DocumentationHeaderMenuLinkItem', title: string, action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } } | { __typename: 'EGDSMenuListIconTextItem', title: string } | { __typename: 'EGDSMenuStandardItem', title: string, icon?: { __typename: 'Icon', token: string } | null } | { __typename: 'EGDSMenuTextItem', title: string }> } | { __typename: 'EGDSStandardSubMenu', title?: string | null, items: Array<{ __typename: 'DocumentationHeaderMenuLinkItem', title: string, action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } } | { __typename: 'EGDSMenuListIconTextItem', title: string } | { __typename: 'EGDSMenuStandardItem', title: string, icon?: { __typename: 'Icon', token: string } | null } | { __typename: 'EGDSMenuTextItem', title: string }> }> } | null, buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UISecondaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UITertiaryButton', primary?: string | null, icon?: { __typename: 'Icon', token: string } | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null }> }, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null } } };

export type RelationshipsLinkFragment = { __typename: 'EGDSStandardLink', text: string, disabled: boolean, size: EgdsLinkSize, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', size?: IconSize | null, token: string, title?: string | null, id: string, description: string } | null };

export type RelatedSectionFragment = { __typename: 'DocumentationRelatedSection', title: { __typename: 'EGDSStylizedText', text: string, weight?: TextWeight | null }, elements: Array<{ __typename: 'DocumentationRelatedDocument', url: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, title: { __typename: 'EGDSStylizedText', text: string, weight?: TextWeight | null }, subtitle?: { __typename: 'EGDSPlainText', text: string } | null }> };

export type RelatedTitleFragment = { __typename: 'EGDSStylizedText', text: string, weight?: TextWeight | null };

export type RelatedSubtitleFragment = { __typename: 'EGDSPlainText', text: string };

export type RelatedUrlFragment = { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } };

export type RelatedElementFragment = { __typename: 'DocumentationRelatedDocument', url: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, title: { __typename: 'EGDSStylizedText', text: string, weight?: TextWeight | null }, subtitle?: { __typename: 'EGDSPlainText', text: string } | null };

export type RelationshipsDataFragment = { __typename: 'DocumentationRelationshipsSuccessResponse', next?: { __typename: 'EGDSStandardLink', text: string, disabled: boolean, size: EgdsLinkSize, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', size?: IconSize | null, token: string, title?: string | null, id: string, description: string } | null } | null, previous?: { __typename: 'EGDSStandardLink', text: string, disabled: boolean, size: EgdsLinkSize, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', size?: IconSize | null, token: string, title?: string | null, id: string, description: string } | null } | null, related?: { __typename: 'DocumentationRelatedSection', title: { __typename: 'EGDSStylizedText', text: string, weight?: TextWeight | null }, elements: Array<{ __typename: 'DocumentationRelatedDocument', url: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, title: { __typename: 'EGDSStylizedText', text: string, weight?: TextWeight | null }, subtitle?: { __typename: 'EGDSPlainText', text: string } | null }> } | null, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null };

export type RelationshipsErrorFragment = { __typename: 'DocumentationRelationshipsErrorResponse', message: string, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null };

export type RelationshipsQueryVariables = Exact<{
  hubId: Scalars['String'];
  documentId: Scalars['String'];
  context: ContextInput;
}>;


export type RelationshipsQuery = { __typename: 'Query', documentation: { __typename: 'Documentation', relationships: { __typename: 'DocumentationDocumentErrorResponse' } | { __typename: 'DocumentationRelationshipsErrorResponse', message: string, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null } | { __typename: 'DocumentationRelationshipsSuccessResponse', next?: { __typename: 'EGDSStandardLink', text: string, disabled: boolean, size: EgdsLinkSize, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', size?: IconSize | null, token: string, title?: string | null, id: string, description: string } | null } | null, previous?: { __typename: 'EGDSStandardLink', text: string, disabled: boolean, size: EgdsLinkSize, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', size?: IconSize | null, token: string, title?: string | null, id: string, description: string } | null } | null, related?: { __typename: 'DocumentationRelatedSection', title: { __typename: 'EGDSStylizedText', text: string, weight?: TextWeight | null }, elements: Array<{ __typename: 'DocumentationRelatedDocument', url: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, title: { __typename: 'EGDSStylizedText', text: string, weight?: TextWeight | null }, subtitle?: { __typename: 'EGDSPlainText', text: string } | null }> } | null, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null } } };

export type SandboxDataFragment = { __typename: 'DocumentationDocumentSuccessResponse', content: string, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null };

export type DocErrorFragment = { __typename: 'DocumentationDocumentErrorResponse', messageText: { __typename: 'EGDSPlainText', text: string }, descriptionText: { __typename: 'EGDSPlainText', text: string }, buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null, action?: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UISecondaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UITertiaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null }>, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null };

export type SandboxQueryVariables = Exact<{
  hubId: Scalars['String'];
  documentId?: InputMaybe<Scalars['String']>;
  referencePath: Scalars['String'];
  context: ContextInput;
}>;


export type SandboxQuery = { __typename: 'Query', documentation: { __typename: 'Documentation', sandbox: { __typename: 'DocumentationDocumentErrorResponse', messageText: { __typename: 'EGDSPlainText', text: string }, descriptionText: { __typename: 'EGDSPlainText', text: string }, buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null, action?: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UISecondaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null } | { __typename: 'UITertiaryButton', primary?: string | null, action?: { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } } | null }>, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null } | { __typename: 'DocumentationDocumentRedirect' } | { __typename: 'DocumentationDocumentSuccessResponse', content: string, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null } } };

export type SearchQueryVariables = Exact<{
  hubId: Scalars['String'];
  context: ContextInput;
  searchTerm: Scalars['String'];
}>;


export type SearchQuery = { __typename: 'Query', documentation: { __typename: 'Documentation', search: { __typename: 'DocumentationSearchResponse', searchResults: Array<{ __typename: 'DocumentationTypeaheadResult', title: string, path: string, intro?: string | null, parentTitles?: string | null }> } } };

export type IconFragment = { __typename: 'Icon', token: string, description: string, title?: string | null, id: string };

export type LinkFragment = { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string, description: string, title?: string | null, id: string } | null };

export type NavigationLinkFragment = { __typename: 'DocumentationNavigationLinkElement', link: { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string, description: string, title?: string | null, id: string } | null }, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null };

export type ExpandoFragment = { __typename: 'DocumentationNavigationExpandoElement', label: string, navigationElements: Array<{ __typename: 'DocumentationNavigationLinkElement', link: { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string, description: string, title?: string | null, id: string } | null }, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null }>, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null };

type NavigationElement_DocumentationNavigationExpandoElement_Fragment = { __typename: 'DocumentationNavigationExpandoElement', label: string, navigationElements: Array<{ __typename: 'DocumentationNavigationLinkElement', link: { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string, description: string, title?: string | null, id: string } | null }, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null }>, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null };

type NavigationElement_DocumentationNavigationLinkElement_Fragment = { __typename: 'DocumentationNavigationLinkElement', link: { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string, description: string, title?: string | null, id: string } | null }, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null };

type NavigationElement_EgdsStandardLink_Fragment = { __typename: 'EGDSStandardLink' };

export type NavigationElementFragment = NavigationElement_DocumentationNavigationExpandoElement_Fragment | NavigationElement_DocumentationNavigationLinkElement_Fragment | NavigationElement_EgdsStandardLink_Fragment;

export type SectionFragment = { __typename: 'DocumentationNavigationSectionElement', heading?: string | null, navigationElements: Array<{ __typename: 'DocumentationNavigationExpandoElement', label: string, navigationElements: Array<{ __typename: 'DocumentationNavigationLinkElement', link: { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string, description: string, title?: string | null, id: string } | null }, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null }>, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null } | { __typename: 'DocumentationNavigationLinkElement', link: { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string, description: string, title?: string | null, id: string } | null }, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null } | { __typename: 'EGDSStandardLink' }>, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null, icon?: { __typename: 'Icon', token: string, description: string, title?: string | null, id: string } | null };

export type SidebarQueryVariables = Exact<{
  hubId: Scalars['String'];
  parentId: Scalars['String'];
  context: ContextInput;
}>;


export type SidebarQuery = { __typename: 'Query', documentation: { __typename: 'Documentation', navigation?: { __typename: 'DocumentationNavigationResponse', elements: Array<{ __typename: 'DocumentationNavigationSectionElement', heading?: string | null, navigationElements: Array<{ __typename: 'DocumentationNavigationExpandoElement', label: string, navigationElements: Array<{ __typename: 'DocumentationNavigationLinkElement', link: { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string, description: string, title?: string | null, id: string } | null }, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null }>, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null } | { __typename: 'DocumentationNavigationLinkElement', link: { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } }, icon?: { __typename: 'Icon', token: string, description: string, title?: string | null, id: string } | null }, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null } | { __typename: 'EGDSStandardLink' }>, badge?: { __typename: 'EGDSBadgeNotification', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', text?: string | null, size?: string | null, theme?: string | null } | null, icon?: { __typename: 'Icon', token: string, description: string, title?: string | null, id: string } | null }>, heading: { __typename: 'DocumentationNavigationHeadingElement', title: { __typename: 'EGDSStylizedText', text: string } }, notifications?: Array<{ __typename: 'UIBanner', message: string, icon?: { __typename: 'Icon', token: string } | null }> | null } | null } };

export const CustomerSurveyLinkFragmentDoc = gql`
    fragment customerSurveyLink on UILinkAction {
  resource {
    value
  }
}
    `;
export const CustomerSurveyButtonFragmentDoc = gql`
    fragment customerSurveyButton on UIPrimaryButton {
  action {
    ...customerSurveyLink
  }
  primary
  icon {
    token
  }
}
    ${CustomerSurveyLinkFragmentDoc}`;
export const CustomerSurveyFragmentDoc = gql`
    fragment customerSurvey on DocumentationCustomerSurveyResponse {
  button {
    ...customerSurveyButton
  }
}
    ${CustomerSurveyButtonFragmentDoc}`;
export const BreadcrumbLinkFragmentDoc = gql`
    fragment breadcrumbLink on EGDSStandardLink {
  text
  action {
    target
    resource {
      value
    }
  }
}
    `;
export const BreadcrumbTextFragmentDoc = gql`
    fragment breadcrumbText on EGDSStylizedText {
  text
}
    `;
export const DocumentDataFragmentDoc = gql`
    fragment documentData on DocumentationDocumentSuccessResponse {
  content
  intro
  title
  thumbnail {
    url
  }
  banner {
    message
    icon {
      token
    }
  }
  notifications {
    message
    icon {
      token
    }
  }
  navigationTrail {
    __typename
    ...breadcrumbLink
    ...breadcrumbText
  }
}
    ${BreadcrumbLinkFragmentDoc}
${BreadcrumbTextFragmentDoc}`;
export const DocumentErrorActionFragmentDoc = gql`
    fragment documentErrorAction on UILinkAction {
  resource {
    value
  }
}
    `;
export const DocumentErrorFragmentDoc = gql`
    fragment documentError on DocumentationDocumentErrorResponse {
  notifications {
    message
    icon {
      token
    }
  }
  messageText {
    text
  }
  descriptionText {
    text
  }
  buttons {
    primary
    action {
      ...documentErrorAction
    }
  }
}
    ${DocumentErrorActionFragmentDoc}`;
export const ReactionButtonFragmentDoc = gql`
    fragment reactionButton on UIPrimaryButton {
  primary
  icon {
    title
    token
    size
  }
}
    `;
export const ReactionFormFragmentDoc = gql`
    fragment reactionForm on SuggestionForm {
  input {
    label
    placeholder
    validations {
      errorMessage
    }
  }
  submit {
    primary
  }
  thankYouMessage {
    text
  }
}
    `;
export const HeaderLogoFragmentDoc = gql`
    fragment headerLogo on DocumentationHeaderLogoElement {
  altText
  imgSrc {
    url
    description
  }
}
    `;
export const HeaderLinkFragmentDoc = gql`
    fragment headerLink on EGDSStandardLink {
  text
  action {
    target
    resource {
      value
    }
  }
}
    `;
export const HeaderElementFragmentDoc = gql`
    fragment headerElement on DocumentationHeaderElement {
  ...headerLink
  ...headerLogo
}
    ${HeaderLinkFragmentDoc}
${HeaderLogoFragmentDoc}`;
export const SearchBoxFragmentDoc = gql`
    fragment searchBox on DocumentationHeaderSearchBoxElement {
  icon {
    title
    description
    size
    id
    token
  }
  indexFileUri {
    value
  }
  placeholder
}
    `;
export const LanguageItemFragmentDoc = gql`
    fragment languageItem on DocumentationHeaderMenuLinkItem {
  title
  label
  action {
    resource {
      value
    }
  }
  icon {
    token
  }
}
    `;
export const LanguageMenuFragmentDoc = gql`
    fragment languageMenu on DocumentationMenu {
  subMenus {
    ... on DocumentationHeaderSubMenu {
      items {
        ...languageItem
      }
    }
  }
  leadingIcon {
    token
  }
  trailingIcon {
    token
  }
}
    ${LanguageItemFragmentDoc}`;
export const AuthenticationLinkFragmentDoc = gql`
    fragment authenticationLink on UILinkAction {
  resource {
    value
  }
  target
}
    `;
export const AuthenticationFragmentDoc = gql`
    fragment authentication on Authentication {
  menu {
    title
    icon {
      token
    }
    buttons {
      primary
      icon {
        token
      }
      action {
        ...authenticationLink
      }
    }
    subMenus {
      title
      items {
        title
        ... on EGDSMenuStandardItem {
          icon {
            token
          }
        }
        ... on DocumentationHeaderMenuLinkItem {
          action {
            resource {
              value
            }
          }
        }
      }
    }
  }
  buttons {
    primary
    icon {
      token
    }
    action {
      ...authenticationLink
    }
  }
}
    ${AuthenticationLinkFragmentDoc}`;
export const DocumentationHeaderFragmentDoc = gql`
    fragment documentationHeader on DocumentationHeaderResponse {
  hubName
  logo {
    ...headerLogo
  }
  primaryNavigation {
    ...headerElement
  }
  secondaryNavigation {
    ...headerElement
  }
  searchBox {
    ...searchBox
  }
  languageMenu {
    ...languageMenu
  }
  authentication {
    ...authentication
  }
  notifications {
    message
    icon {
      token
    }
  }
}
    ${HeaderLogoFragmentDoc}
${HeaderElementFragmentDoc}
${SearchBoxFragmentDoc}
${LanguageMenuFragmentDoc}
${AuthenticationFragmentDoc}`;
export const RelationshipsLinkFragmentDoc = gql`
    fragment relationshipsLink on EGDSStandardLink {
  text
  disabled
  size
  action {
    target
    resource {
      value
    }
  }
  icon {
    size
    token
    title
    id
    description
  }
}
    `;
export const RelatedTitleFragmentDoc = gql`
    fragment relatedTitle on EGDSStylizedText {
  text
  weight
}
    `;
export const RelatedUrlFragmentDoc = gql`
    fragment relatedUrl on UILinkAction {
  resource {
    value
  }
}
    `;
export const RelatedSubtitleFragmentDoc = gql`
    fragment relatedSubtitle on EGDSPlainText {
  text
}
    `;
export const RelatedElementFragmentDoc = gql`
    fragment relatedElement on DocumentationRelatedDocument {
  url {
    ...relatedUrl
  }
  title {
    ...relatedTitle
  }
  subtitle {
    ...relatedSubtitle
  }
}
    ${RelatedUrlFragmentDoc}
${RelatedTitleFragmentDoc}
${RelatedSubtitleFragmentDoc}`;
export const RelatedSectionFragmentDoc = gql`
    fragment relatedSection on DocumentationRelatedSection {
  title {
    ...relatedTitle
  }
  elements {
    ...relatedElement
  }
}
    ${RelatedTitleFragmentDoc}
${RelatedElementFragmentDoc}`;
export const RelationshipsDataFragmentDoc = gql`
    fragment relationshipsData on DocumentationRelationshipsSuccessResponse {
  next {
    ...relationshipsLink
  }
  previous {
    ...relationshipsLink
  }
  related {
    ...relatedSection
  }
  notifications {
    message
    icon {
      token
    }
  }
}
    ${RelationshipsLinkFragmentDoc}
${RelatedSectionFragmentDoc}`;
export const RelationshipsErrorFragmentDoc = gql`
    fragment relationshipsError on DocumentationRelationshipsErrorResponse {
  message
  notifications {
    message
    icon {
      token
    }
  }
}
    `;
export const SandboxDataFragmentDoc = gql`
    fragment sandboxData on DocumentationDocumentSuccessResponse {
  content
  notifications {
    message
    icon {
      token
    }
  }
}
    `;
export const DocErrorFragmentDoc = gql`
    fragment docError on DocumentationDocumentErrorResponse {
  messageText {
    text
  }
  descriptionText {
    text
  }
  buttons {
    primary
    action {
      ...documentErrorAction
    }
  }
  notifications {
    message
    icon {
      token
    }
  }
}
    ${DocumentErrorActionFragmentDoc}`;
export const IconFragmentDoc = gql`
    fragment icon on Icon {
  token
  description
  title
  id
}
    `;
export const LinkFragmentDoc = gql`
    fragment link on EGDSStandardLink {
  text
  action {
    target
    resource {
      value
    }
  }
  icon {
    ...icon
  }
}
    ${IconFragmentDoc}`;
export const NavigationLinkFragmentDoc = gql`
    fragment navigationLink on DocumentationNavigationLinkElement {
  link {
    ...link
  }
  badge {
    text
    size
    theme
  }
}
    ${LinkFragmentDoc}`;
export const ExpandoFragmentDoc = gql`
    fragment expando on DocumentationNavigationExpandoElement {
  label
  navigationElements {
    ...navigationLink
  }
  badge {
    text
    size
    theme
  }
}
    ${NavigationLinkFragmentDoc}`;
export const NavigationElementFragmentDoc = gql`
    fragment navigationElement on DocumentationNavigationElement {
  ...navigationLink
  ...expando
}
    ${NavigationLinkFragmentDoc}
${ExpandoFragmentDoc}`;
export const SectionFragmentDoc = gql`
    fragment section on DocumentationNavigationSectionElement {
  heading
  navigationElements {
    ...navigationElement
  }
  badge {
    text
    size
    theme
  }
  icon {
    token
    description
    title
    id
  }
}
    ${NavigationElementFragmentDoc}`;
export const CustomerSurveyDocument = gql`
    query CustomerSurvey($hubId: String!, $context: ContextInput!) {
  documentation(hubId: $hubId, context: $context) {
    customerSurvey {
      ...customerSurvey
    }
  }
}
    ${CustomerSurveyFragmentDoc}`;

/**
 * __useCustomerSurveyQuery__
 *
 * To run a query within a React component, call `useCustomerSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSurveyQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useCustomerSurveyQuery(baseOptions: Apollo.QueryHookOptions<CustomerSurveyQuery, CustomerSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSurveyQuery, CustomerSurveyQueryVariables>(CustomerSurveyDocument, options);
      }
export function useCustomerSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSurveyQuery, CustomerSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSurveyQuery, CustomerSurveyQueryVariables>(CustomerSurveyDocument, options);
        }
export type CustomerSurveyQueryHookResult = ReturnType<typeof useCustomerSurveyQuery>;
export type CustomerSurveyLazyQueryHookResult = ReturnType<typeof useCustomerSurveyLazyQuery>;
export type CustomerSurveyQueryResult = Apollo.QueryResult<CustomerSurveyQuery, CustomerSurveyQueryVariables>;
export const DocumentDocument = gql`
    query Document($hubId: String!, $documentId: String!, $context: ContextInput!) {
  documentation(hubId: $hubId, context: $context) {
    document(id: $documentId) {
      ...documentData
      ...documentError
    }
  }
}
    ${DocumentDataFragmentDoc}
${DocumentErrorFragmentDoc}`;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      documentId: // value for 'documentId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDocumentQuery(baseOptions: Apollo.QueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
      }
export function useDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
        }
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<typeof useDocumentLazyQuery>;
export type DocumentQueryResult = Apollo.QueryResult<DocumentQuery, DocumentQueryVariables>;
export const FeedbackDocument = gql`
    query Feedback($hubId: String!, $context: ContextInput!) {
  documentation(hubId: $hubId, context: $context) {
    feedback {
      question {
        text
      }
      suggestionForm {
        ...reactionForm
      }
      thumpsDown {
        ...reactionButton
      }
      thumpsUp {
        ...reactionButton
      }
      notifications {
        message
        icon {
          token
        }
      }
    }
  }
}
    ${ReactionFormFragmentDoc}
${ReactionButtonFragmentDoc}`;

/**
 * __useFeedbackQuery__
 *
 * To run a query within a React component, call `useFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useFeedbackQuery(baseOptions: Apollo.QueryHookOptions<FeedbackQuery, FeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument, options);
      }
export function useFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackQuery, FeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument, options);
        }
export type FeedbackQueryHookResult = ReturnType<typeof useFeedbackQuery>;
export type FeedbackLazyQueryHookResult = ReturnType<typeof useFeedbackLazyQuery>;
export type FeedbackQueryResult = Apollo.QueryResult<FeedbackQuery, FeedbackQueryVariables>;
export const HeaderDocument = gql`
    query Header($hubId: String!, $context: ContextInput!) {
  documentation(hubId: $hubId, context: $context) {
    header {
      ...documentationHeader
    }
  }
}
    ${DocumentationHeaderFragmentDoc}`;

/**
 * __useHeaderQuery__
 *
 * To run a query within a React component, call `useHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useHeaderQuery(baseOptions: Apollo.QueryHookOptions<HeaderQuery, HeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderQuery, HeaderQueryVariables>(HeaderDocument, options);
      }
export function useHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderQuery, HeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderQuery, HeaderQueryVariables>(HeaderDocument, options);
        }
export type HeaderQueryHookResult = ReturnType<typeof useHeaderQuery>;
export type HeaderLazyQueryHookResult = ReturnType<typeof useHeaderLazyQuery>;
export type HeaderQueryResult = Apollo.QueryResult<HeaderQuery, HeaderQueryVariables>;
export const RelationshipsDocument = gql`
    query relationships($hubId: String!, $documentId: String!, $context: ContextInput!) {
  documentation(hubId: $hubId, context: $context) {
    relationships(id: $documentId) {
      ...relationshipsData
      ...relationshipsError
    }
  }
}
    ${RelationshipsDataFragmentDoc}
${RelationshipsErrorFragmentDoc}`;

/**
 * __useRelationshipsQuery__
 *
 * To run a query within a React component, call `useRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationshipsQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      documentId: // value for 'documentId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useRelationshipsQuery(baseOptions: Apollo.QueryHookOptions<RelationshipsQuery, RelationshipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelationshipsQuery, RelationshipsQueryVariables>(RelationshipsDocument, options);
      }
export function useRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelationshipsQuery, RelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelationshipsQuery, RelationshipsQueryVariables>(RelationshipsDocument, options);
        }
export type RelationshipsQueryHookResult = ReturnType<typeof useRelationshipsQuery>;
export type RelationshipsLazyQueryHookResult = ReturnType<typeof useRelationshipsLazyQuery>;
export type RelationshipsQueryResult = Apollo.QueryResult<RelationshipsQuery, RelationshipsQueryVariables>;
export const SandboxDocument = gql`
    query Sandbox($hubId: String!, $documentId: String, $referencePath: String!, $context: ContextInput!) {
  documentation(hubId: $hubId, context: $context) {
    sandbox(referencePath: $referencePath, documentId: $documentId) {
      ...sandboxData
      ...docError
    }
  }
}
    ${SandboxDataFragmentDoc}
${DocErrorFragmentDoc}`;

/**
 * __useSandboxQuery__
 *
 * To run a query within a React component, call `useSandboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      documentId: // value for 'documentId'
 *      referencePath: // value for 'referencePath'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useSandboxQuery(baseOptions: Apollo.QueryHookOptions<SandboxQuery, SandboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SandboxQuery, SandboxQueryVariables>(SandboxDocument, options);
      }
export function useSandboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SandboxQuery, SandboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SandboxQuery, SandboxQueryVariables>(SandboxDocument, options);
        }
export type SandboxQueryHookResult = ReturnType<typeof useSandboxQuery>;
export type SandboxLazyQueryHookResult = ReturnType<typeof useSandboxLazyQuery>;
export type SandboxQueryResult = Apollo.QueryResult<SandboxQuery, SandboxQueryVariables>;
export const SearchDocument = gql`
    query Search($hubId: String!, $context: ContextInput!, $searchTerm: String!) {
  documentation(hubId: $hubId, context: $context) {
    search(term: $searchTerm) {
      ... on DocumentationSearchResponse {
        searchResults {
          title
          path
          intro
          parentTitles
        }
      }
    }
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      context: // value for 'context'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const SidebarDocument = gql`
    query Sidebar($hubId: String!, $parentId: String!, $context: ContextInput!) {
  documentation(hubId: $hubId, context: $context) {
    navigation(parentId: $parentId) {
      elements {
        ...section
      }
      heading {
        title {
          text
        }
      }
      notifications {
        message
        icon {
          token
        }
      }
    }
  }
}
    ${SectionFragmentDoc}`;

/**
 * __useSidebarQuery__
 *
 * To run a query within a React component, call `useSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSidebarQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      parentId: // value for 'parentId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useSidebarQuery(baseOptions: Apollo.QueryHookOptions<SidebarQuery, SidebarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SidebarQuery, SidebarQueryVariables>(SidebarDocument, options);
      }
export function useSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SidebarQuery, SidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SidebarQuery, SidebarQueryVariables>(SidebarDocument, options);
        }
export type SidebarQueryHookResult = ReturnType<typeof useSidebarQuery>;
export type SidebarLazyQueryHookResult = ReturnType<typeof useSidebarLazyQuery>;
export type SidebarQueryResult = Apollo.QueryResult<SidebarQuery, SidebarQueryVariables>;